import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Component, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController, Slides, ViewController, AlertController, MenuController, App } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import * as $ from 'jquery';
import firebase from 'firebase/app';
import { AngularFireAuth } from 'angularfire2/auth';
import { Http, Headers, RequestOptions } from '@angular/http';
import { LoadingProvider } from '../../providers/loading/loading';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { ViewContactPage } from '../view-contact/view-contact';
import { HomePage } from '../home/home';
import { SdfFormService } from '../../app/services/sdf-form-service';
//import { post } from 'jquery';
import { AngularFireStorage } from 'angularfire2/storage';
import { fromEvent } from 'rxjs';
import { debounceTime, take } from "rxjs/operators";
import {EnvDataService} from '../../app/services/env-data-service';
declare var google;


@Component({
  selector: 'page-stepform',
  templateUrl: 'stepform.html',
  providers:[EnvDataService]
})
export class StepformPage {

  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  @ViewChild('addresstext') addresstext: any;

  @ViewChild(Slides) signupSlider: Slides;
  @ViewChild('dateOfBirth') datePicker;



  public autoCorrectedDatePipe = createAutoCorrectedDatePipe('mm/dd/yyyy HH:MM');
  public numberMask = createNumberMask({
    prefix: '$ ',
    allowDecimal: true,
    decimalSymbol : ".",
    decimalLimit : 2,
    suffix: ' '
  })

  slideOneForm: FormGroup;
  slideTwoForm: FormGroup;
  slideThreeForm: FormGroup;
  slideFourForm: FormGroup;
  incomeForm: FormGroup;
  assetsForm : FormGroup;
  liabilitiesForm : FormGroup;
  realEstateForm : FormGroup;

  public form_name: any;
  public address_format;
  public rand= new Date().getTime();
  public do_you_have_children_yes_or_no;
  public how_many_children_number;
  public employementType;
  public isCurrentEmployeed;
  public isemployementType;
  public expectedWork;
  public statusEmployment;
  public new_uid;
  public allAssets: any;
  public allAssetss: any;
  public allLiabilities: any;
  public allLiabilitiess: any;
  public allIncomes: any;
  public allIncomess: any;
  public total_a_length: any;
  public total_l_length: any;
  public total_i_length: any;
  public allSecApplicant: any;
  public streetname;
  public applicant_type;
  public how_many_children: any;
  public edit_contact_uid : any;
  public user_data;
  public selected_type : any;
  public deleted_access : any
  public userRole: any;
  public firstname : any;
  public lastname : any;
  public date_of_birth: any;
  public secondary: false;
  public change_log_string: any;
  public applicant_details: any;
  public secondary_details: any;
  public dependents_family_details: any;
  public employment_details: any;
  public income_details: any;
  public asset_details: any;
  public liability_details: any;
  public realEstate_details: any;
  public new_val: any;
  public old_val: any;
  public totalIncomes: number;
  public broker_uid_for_second_contact: any;
  public totalRealEstates: any;
  public allBrokers: any;
  public check_create_update: number;
  public primary_conatct_id_for_user_history: any;
  public usersCollection: any;
  public employmentCollection: any;
  public incomeCollection: any;
  public assetsCollection: any;
  public liabilitiesCollection: any;
  public realEstatesCollection: any;
  public userHistoryCollection: any;
  public showPrimaryApplicantAddress: number = 1;
  public showAdditional_address: number = -1;
  public showPrimaryApplicantEmployement: number = 1;
  public showAdditional_employement: number = -1;
  public showPrimaryApplicantFamily = 1;
  public showAdditionalFamily = -1;
  public secondary_contact: any;
  public primary_uid: any;
  public secondary_uid: any;
  public document_id: any;
  public SDF_form_document_id: any;
  public newASFCreating: number = 0;
  public allRealEstatess: any;
  public percentage_0: any;
  public percentage_1: any;
  public percentage_2: any;
  public percentage_3: any;
  public percentage_4: any;
  public percentage_5: any;
  public allSecondaryContacts: any;
  public sec_data: any;
  public dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public asset_value: any;
  public indexx : number;
  public emailList: any[];
  public allUserData: any;
  public isItemAvailable = false;
  public checkContact: number;
  public checkAddiContact: any;
  public checkAddiContactStatus: number;

  postRef: AngularFirestoreDocument<any>;

  submitAttempt: boolean = false;

  public validation_messages = {
      'firstname': [
          { type: 'required', message: 'Firstname is required.' }
      ],
      'lastname': [
        { type: 'required', message: 'Lastname is required.' }
      ],
      'email': [
        { type: 'required', message: 'Email is required.' }
      ],
      'mobile_phone': [
        { type: 'required', message: 'Mobile Number is required.' },
        { type: 'minlength', message: 'Mobile Number must be at least 10 digit long.' },
        { type: 'maxlength', message: 'Mobile Number must be at least 10 digit long.' }
      ],
      'date_of_birth': [
        { type: 'required', message: 'Date of Birth is required.' }
      ],
      'secondary_firstname': [
        { type: 'required', message: 'Firstname is required.' }
      ],
      'secondary_lastname': [
        { type: 'required', message: 'Lastname is required.' }
      ],
      'secondary_email': [
        { type: 'required', message: 'Email is required.' }
      ],
      'secondary_mobile_phone': [
        { type: 'required', message: 'Mobile Number is required.' },
        { type: 'minlength', message: 'Mobile Number must be at least 10 digit long.' },
        { type: 'maxlength', message: 'Mobile Number must be at least 10 digit long.' }
      ],
      'secondary_date_of_birth': [
        { type: 'required', message: 'Date of Birth is required.' }
      ],
      'primayr_goal_intention': [
        { type: 'required', message: 'Primary goal/intention of the applicant is required.' }
      ],
      'address_type': [
        { type: 'required', message: 'Address Type is required.' }
      ],
      'address_format': [
        { type: 'required', message: 'Address format is required.' }
      ],
      'street_number': [
        { type: 'required', message: 'Street Number is required.' }
      ],
      'street_name': [
        { type: 'required', message: 'Street Name is required.' }
      ],
      'street_type': [
        { type: 'required', message: 'Street Type is required.' }
      ],
      'city': [
        { type: 'required', message: 'City is required.' }
      ],
      'state': [
        { type: 'required', message: 'State is required.' }
      ],
      'postcode': [
        { type: 'required', message: 'Postcode is required.' }
      ],
      'country': [
        { type: 'required', message: 'Country is required.' }
      ],
      'housing_situation': [
        { type: 'required', message: 'Housing situation is required.' }
      ],
      'move_in_date': [
        { type: 'required', message: 'Move in date is required.' }
      ],
      'previous_address_type': [
        { type: 'required', message: 'Address Type is required.' }
      ],
      'previous_address_format': [
        { type: 'required', message: 'Address format is required.' }
      ],
      'previous_street_number': [
        { type: 'required', message: 'Street Number is required.' }
      ],
      'previous_street_name': [
        { type: 'required', message: 'Street Name is required.' }
      ],
      'previous_street_type': [
        { type: 'required', message: 'Street Type is required.' }
      ],
      'previous_city': [
        { type: 'required', message: 'City is required.' }
      ],
      'previous_state': [
        { type: 'required', message: 'State is required.' }
      ],
      'previous_postcode': [
        { type: 'required', message: 'Postcode is required.' }
      ],
      'previous_country': [
        { type: 'required', message: 'Country is required.' }
      ],
      'previous_housing_situation': [
        { type: 'required', message: 'Housing situation is required.' }
      ],
      'previous_move_in_date': [
        { type: 'required', message: 'Move in date is required.' }
      ],
      'previous_move_out_date': [
        { type: 'required', message: 'Move out date is required.' }
      ],
      'reference_broker': [
        { type: 'required', message: 'Broker is required.' }
      ],
      'gender': [
        { type: 'required', message: 'Gender is required.' }
      ],
      'current_marital_status': [
        { type: 'required', message: 'Merital status is required.' }
      ],
      'do_you_have_children': [
        { type: 'required', message: 'Do you have children?' }
      ],
      'how_many_children': [
        { type: 'required', message: 'Enter How many dependents do you have under the age of 18?' }
      ],
      'first_child_age': [
        { type: 'required', message: 'Enter Child Age.' }
      ],
      'second_child_age': [
        { type: 'required', message: 'Enter Child Age.' }
      ],
      'third_child_age': [
        { type: 'required', message: 'Enter Child Age.' }
      ],
      'fourth_child_age': [
        { type: 'required', message: 'Enter Child Age.' }
      ],
      'fifth_child_age': [
        { type: 'required', message: 'Enter Child Age.' }
      ],
      'sixth_child_age': [
        { type: 'required', message: 'Enter Child Age.' }
      ],
      'employementType': [
        { type: 'required', message: 'Employment type required.' }
      ],
      'currentlyEmployment': [
        { type: 'required', message: 'Current employment required.' }
      ],
      'expectFindWork': [
        { type: 'required', message: 'Enter expect find work.' }
      ],
      'statusyourEmployment': [
        { type: 'required', message: 'Status your employment required.' }
      ],
      'your_occupation': [
        { type: 'required', message: 'Your occupation required.' }
      ],
      'start_date': [
        { type: 'required', message: 'When did you start in this role required.' }
      ],
      'business_name': [
        { type: 'required', message: 'Business name required.' }
      ],
      'nature_of_business': [
        { type: 'required', message: 'Nature of business required.' }
      ],
      'amount': [
        { type: 'required', message: 'This field is required.' }
      ],
      'frequency': [
        { type: 'required', message: 'This field is required.' }
      ],
      'date_commenced': [
        { type: 'required', message: 'This field is required.' }
      ],
      'percentage_asset': [
        { type: 'max', message: 'Must be less than 100.' },
        { type: 'min', message: 'Must be greater than 1.' },
        { type: 'required', message: 'This field is required.' }
      ],
      'asset_value': [
        { type: 'maxlength', message: 'Maximum length should be 30.' },
        { type: 'minlength', message: 'Must be greater than 1.' },
        { type: 'required', message: 'This field is required.' }
      ],
      'current_balance': [
        { type: 'maxlength', message: 'Maximum length should be 30.' },
        { type: 'minlength', message: 'Must be greater than 1.' },
        { type: 'required', message: 'This field is required.' }
      ],
      'limit': [
        { type: 'maxlength', message: 'Maximum length should be 30.' },
        { type: 'minlength', message: 'Must be greater than 1.' },
        { type: 'required', message: 'This field is required.' }
      ],
      'repayments': [
        { type: 'maxlength', message: 'Maximum length should be 30.' },
        { type: 'minlength', message: 'Must be greater than 1.' },
        { type: 'required', message: 'This field is required.' }
      ],
      'asset_type': [
        { type: 'required', message: 'Asset type is required.' }
      ],
      'value_basis': [
        { type: 'required', message: 'Value basis is required.' }
      ],
      'ownership_title_name': [
        { type: 'required', message: 'Ownership title name is required.' }
      ],
      'primary_percentage_asset': [
        { type: 'required', message: 'Ownership percentage is required.' }
      ],
      'secondary_percentage_asset': [
        { type: 'required', message: 'Ownership percentage is required.' }
      ],
      'notes': [
        { type: 'required', message: 'Notes is required.' }
      ],
      'gross_amount': [
        { type: 'required', message: 'Rental Income Per Week is required' }
      ],
      'creditor': [
        { type: 'required', message: 'Creditor is required.' }
      ],
      'available_redraw': [
        { type: 'required', message: 'Redraw Offset is required.' }
      ],
      'loan_type': [
        { type: 'required', message: 'Load type is required.' }
      ],
      'interest_rate': [
        { type: 'required', message: 'Interest rate is required.' },
        { type: 'min', message: 'Interest rate minimum value 1.' },
        { type: 'max', message: 'Interest rate maximum value 100.' }
      ],
      'interest_rate_term': [
        { type: 'required', message: 'Interest rate term is required.' }
      ]
    }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public db: AngularFirestore,
    public modalCtrl: ModalController,
    public afAuth:AngularFireAuth,
    public http: Http,
    public toastCtrl: ToastController,
    public loadingProvider: LoadingProvider,
    public viewCtrl: ViewController,
    public alertCtrl: AlertController,
    public menuCtrl: MenuController,
    public app: App,
    private storage: AngularFireStorage,
    public SdfFormService: SdfFormService,
    public el: ElementRef,
    private EnvDataService:EnvDataService
    ) {

    this.secondary_contact = false;
    this.allIncomess = [];
    this.allLiabilitiess = [];
    this.secondary_uid = [];
    this.broker_uid_for_second_contact = '';
    this.new_val = '';
    this.old_val = '';
    this.change_log_string = [];
    this.applicant_details = '';
    this.secondary_details = [];
    this.employment_details = '';
    this.income_details = [];
    this.asset_details = [];
    this.liability_details = [];
    this.realEstate_details = [];
    this.dependents_family_details = '';
    this.user_data = '';
    this.totalIncomes = 0;
    this.edit_contact_uid = this.navParams.get("edit_contact_uid");
    this.SDF_form_document_id = this.navParams.get("SDF_form_document_id");
    this.check_create_update = 0;
    this.checkContact = 0;
    this.checkAddiContact = [];
    this.checkAddiContactStatus = 0;

    this.usersCollection = firebase.firestore().collection("users");
    this.employmentCollection = firebase.firestore().collection("employment");
    this.incomeCollection = firebase.firestore().collection("SDF_income");
    this.assetsCollection = firebase.firestore().collection("SDF_assets");
    this.liabilitiesCollection = firebase.firestore().collection("SDF_liabilities");
    this.realEstatesCollection = firebase.firestore().collection("SDF_realestate");
    this.userHistoryCollection = firebase.firestore().collection("user_history");
    
    this.applicant_type = "Primary";
    this.form_name = "eLINK Finance";
    this.deleted_access = window.localStorage.getItem("deleted_access");
    this.userRole = window.localStorage.getItem("userRole");
    let thiss = this;

    // if(this.userRole == "super_admin" || this.userRole == "loan_admin"){}else{
    //   this.slideOneForm.get('reference_broker').setValidators(null);
    //   this.slideOneForm.get('reference_broker').updateValueAndValidity();
    // }
    if(thiss.SDF_form_document_id != undefined){
      window.localStorage.setItem("SDF_form_document_id", thiss.SDF_form_document_id);
      let SDF_form = firebase.firestore().collection("SDF_form").doc(thiss.SDF_form_document_id);
      SDF_form.get().then(function(SDF_form_doc) {
        if (SDF_form_doc.exists) {
          let sdf_data = SDF_form_doc.data();
          let main_uid = sdf_data.uid;
          thiss.primary_uid = main_uid;
          thiss.edit_contact_uid = sdf_data.uid;
          let docRef1 = firebase.firestore().collection("users").doc(main_uid);
          docRef1.get().then(function(doc) {
            if (doc.exists) {
              thiss.editgetSDFUser(thiss.SDF_form_document_id, main_uid).subscribe((data)=>{
                if(data.length > 0){
                  data.forEach(uData => {
                    if(uData.contact_type == "Primary Contact"){
                      var mobile_phone = doc.data().mobile_phone;
                      mobile_phone = mobile_phone.split(" ").join("");
                      let firstFour = mobile_phone.slice(0, 4);
                      let number = mobile_phone.slice(4, 10);
                      number = firstFour + ' ' + number.slice(0, 3) + ' ' + number.slice(3);
                      setTimeout(_ => {
                        thiss.slideOneForm.controls.firstname.setValue(uData.firstname);
                        thiss.slideOneForm.controls.middlename.setValue(uData.middlename);
                        thiss.slideOneForm.controls.lastname.setValue(uData.lastname);
                        thiss.slideOneForm.controls.email.setValue(doc.data().email);
                        thiss.slideOneForm.controls.mobile_phone.setValue(number);
                        thiss.slideOneForm.controls.date_of_birth.setValue(uData.date_of_birth);
                        thiss.slideOneForm.controls.primayr_goal_intention.setValue(uData.primayr_goal_intention);
        
                        thiss.slideOneForm.controls.address_type.setValue(uData.address_type);
                        thiss.slideOneForm.controls.address_format.setValue(uData.address_format);
                        thiss.slideOneForm.controls.floor_number.setValue(uData.floor_number);
                        thiss.slideOneForm.controls.unit_number.setValue(uData.unit_number);
                        thiss.slideOneForm.controls.building_name.setValue(uData.building_name);
                        thiss.slideOneForm.controls.poboxlabel.setValue(uData.poboxlabel);
                        thiss.slideOneForm.controls.street_number.setValue(uData.street_number);
                        thiss.slideOneForm.controls.street_name.setValue(uData.street_name);
                        thiss.slideOneForm.controls.street_type.setValue(uData.street_type);
                        thiss.slideOneForm.controls.city.setValue(uData.city);
                        thiss.slideOneForm.controls.state.setValue(uData.state);
                        thiss.slideOneForm.controls.postcode.setValue(uData.postcode);
                        thiss.slideOneForm.controls.country.setValue(uData.country);
                        thiss.slideOneForm.controls.housing_situation.setValue(uData.housing_situation);
                        thiss.slideOneForm.controls.move_in_date.setValue(uData.move_in_date);
                        thiss.slideOneForm.controls.user_document_id.setValue(uData.document_id);
        
                        thiss.slideOneForm.controls.reference_broker.setValue(uData.reference_broker);
                        
                        thiss.slideTwoForm.controls.gender.setValue((uData.gender != undefined) ? uData.gender : 'Male');
                        thiss.slideTwoForm.controls.current_marital_status.setValue(uData.current_marital_status);
                        thiss.slideTwoForm.controls.do_you_have_children.setValue(uData.do_you_have_children);
                        thiss.slideTwoForm.controls.how_many_children.setValue(uData.how_many_children);
                        thiss.slideTwoForm.controls.first_child_age.setValue(uData.first_child_age);
                        thiss.slideTwoForm.controls.second_child_age.setValue(uData.second_child_age);
                        thiss.slideTwoForm.controls.third_child_age.setValue(uData.third_child_age);
                        thiss.slideTwoForm.controls.fourth_child_age.setValue(uData.fourth_child_age);
                        thiss.slideTwoForm.controls.fifth_child_age.setValue(uData.fifth_child_age);
                        thiss.slideTwoForm.controls.sixth_child_age.setValue(uData.sixth_child_age);
                        thiss.how_many_children_number = uData.how_many_children;
                      });
                      if(uData.previousAddress !=  undefined && uData.previousAddress.length > 0){
                        uData.previousAddress.forEach(uDatapa => {
                          thiss.formPreviousAddress.push(thiss.initaddPreviousAddressLoad(uDatapa));
                        });
                      }
                      thiss.applicant_details = uData;
                      firebase.firestore().collection("employment").where("SDF_form", "==", thiss.SDF_form_document_id).where("uid", "==", main_uid).get()
                      .then(function(querySnapshot2) {
                        querySnapshot2.forEach(function(empDoc) {
                          setTimeout(_ => {
                            thiss.slideThreeForm.controls.employementType.setValue(empDoc.data().employementType);
                            thiss.slideThreeForm.controls.currentlyEmployment.setValue(empDoc.data().currentlyEmployment);
                            thiss.slideThreeForm.controls.expectFindWork.setValue(empDoc.data().expectFindWork);
                            thiss.slideThreeForm.controls.statusyourEmployment.setValue(empDoc.data().statusyourEmployment);
                            thiss.slideThreeForm.controls.your_occupation.setValue(empDoc.data().your_occupation);
                            thiss.slideThreeForm.controls.start_date.setValue(empDoc.data().start_date);
                            thiss.slideThreeForm.controls.business_name.setValue(empDoc.data().business_name);
                            thiss.slideThreeForm.controls.type_of_entity.setValue(doc.data().type_of_entity);
                            thiss.slideThreeForm.controls.abn_acn.setValue(empDoc.data().abn_acn);
                            thiss.slideThreeForm.controls.nature_of_business.setValue(empDoc.data().nature_of_business);
                            thiss.changeEmploymentType(empDoc.data().employementType, 'employementType');
                            if(empDoc.data().employementType == 'payg'){
                              thiss.currentEmployeed(empDoc.data().currentlyEmployment, 'currentlyEmployment');
                            }
                          });
                          if(empDoc.data().primaryEmployment !=  undefined && empDoc.data().primaryEmployment.length > 0){
                            let i = 0;
                            empDoc.data().primaryEmployment.forEach(uDatape => {
                              thiss.formPrimaryEmployment.push(thiss.initaddPrimaryEmploymentLoad(uDatape));
                              thiss.changeEmploymentTypePrev(uDatape.employementType, i);
                              if(empDoc.data().employementType == 'payg'){
                                thiss.currentEmployeedPrev(uDatape.currentlyEmployment, i);
                              }
                              i++;
                            });
                          }
                          thiss.employment_details = empDoc.data();
                        });
                      });
                      thiss.formPrimaryEmployment.updateValueAndValidity();
                    }
                  });
                }
              });
              thiss.editgetIncomes(main_uid).subscribe((editgetIncomes)=>{
                if(editgetIncomes.length > 0 && thiss.formArr.length == 0){
                  editgetIncomes.forEach(uData => {
                    thiss.formArr.push(thiss.initItemRowsIncomesLoad(uData));
                  })
                }
              });
              thiss.editgetassets(thiss.SDF_form_document_id).subscribe((editgetassets)=>{
                if(editgetassets.length > 0 && thiss.formArrAssets.length == 0){
                  editgetassets.forEach(uData => {
                    thiss.formArrAssets.push(thiss.initItemRowsAssetsLoad(uData));
                  })
                }
              });
              thiss.editgetLiabilities(main_uid).subscribe((editgetLiabilities)=>{
                if(editgetLiabilities.length > 0 && thiss.formArrLiabilities.length == 0){
                  let i = 0;
                  editgetLiabilities.forEach(uData => {
                    thiss.formArrLiabilities.push(thiss.initItemRowsLiabilitiesLoad(uData));
                    var getRepayments = thiss.formArrLiabilities.at(i).get('repayments');
                    var type_value = uData.liability_type;
                    if(type_value == 'Commercial Bill' || type_value == 'HECS' || type_value == 'Hire Purchase' || type_value == 'Maintenance' || type_value == 'Outstanding Taxation' || type_value == 'Other'){
                      getRepayments.setValidators(null);
                      getRepayments.updateValueAndValidity();
                    }else{
                      getRepayments.setValidators(Validators.required);
                      getRepayments.updateValueAndValidity();
                    }
                    i++;
                  })
                }
              });
              thiss.editgetRealEstate(thiss.SDF_form_document_id).subscribe((data)=>{
                if(data.length > 0 && thiss.formArrRealEstates.length == 0){
                  thiss.allRealEstatess = data;
                  for(let j = 0; j < thiss.allRealEstatess.length; j++){
                    thiss.editgetRealEstateSplit(thiss.allRealEstatess[j].document_id).subscribe((splitdata)=>{
                      thiss.formArrRealEstates.controls[j]['controls']['itemRowsMortgageSplits'].removeAt(0);
                      let allSplitData = [];
                      if(splitdata.length > 0 && thiss.formArrRealEstates.controls[j]['controls']['itemRowsMortgageSplits'].length == 0){
                        for(let l = 0; l < splitdata.length; l++){
                          allSplitData.push(thiss.initItemRowsMortgageSplitLoad(splitdata[l]));
                          thiss.formArrRealEstates.controls[j]['controls']['itemRowsMortgageSplits'].push(thiss.initItemRowsMortgageSplitLoad(splitdata[l]));
                        }
                      }
                    });
                    thiss.formArrRealEstates.push(thiss.initItemRowsRealEstatesLoad(thiss.allRealEstatess[j]));
                  }
                }
              })
            }
          })

          thiss.SdfFormService.get_second_user_data(thiss.SDF_form_document_id)
          .then((get_second_user_data) => {
            Object.keys(get_second_user_data).forEach(function(key) {
              thiss.secondary_uid.push({'secondary_uid': get_second_user_data[key].uid, 'document_id': get_second_user_data[key].document_id})
              var secondUser = firebase.firestore().collection("users").doc(get_second_user_data[key].uid);
              secondUser.get().then(function(secdoc) {
                get_second_user_data[key].email = secdoc.data().email;
                get_second_user_data[key].mobile_phone = secdoc.data().mobile_phone;
                thiss.formApplicant.push(thiss.initItemRowsApplicantLoad(get_second_user_data[key]));
                thiss.formApplicantFamily.push(thiss.initaddAnotherApplicantFamilyLoad(get_second_user_data[key]));
                firebase.firestore().collection("employment").where("SDF_form", "==", thiss.SDF_form_document_id).where("uid", "==", get_second_user_data[key].uid).get()
                .then(function(querySnapshotEmp) {
                  let i = 0;
                  querySnapshotEmp.forEach(function(empDoc) {
                    thiss.formApplicantEmployment.push(thiss.initaddAnotherApplicantEmploymentLoad(empDoc.data()));
                    thiss.changeEmploymentTypeaddi(empDoc.data().employementType, key);
                    if(empDoc.data().employementType == 'payg'){
                      thiss.currentEmployeedaddi(empDoc.data().currentlyEmployment, key);
                    }

                    if(empDoc.data().primaryEmployment !=  undefined && empDoc.data().primaryEmployment.length > 0){
                      let ii = 0;
                      empDoc.data().primaryEmployment.forEach(uDatape => {
                        thiss.formApplicantEmployment.controls[i]['controls'].previousEmploymentItem.push(thiss.initaddPrimaryEmploymentLoad(uDatape));
                        thiss.changeEmploymentTypeAddiPrev(uDatape.employementType, i, ii);
                        if(empDoc.data().employementType == 'payg'){
                          thiss.currentEmployeedAddiPrev(uDatape.currentlyEmployment, i, ii);
                        }
                        ii++;
                      });
                    }
                    i++;
                  });
                  if(querySnapshotEmp.empty){
                    thiss.formApplicantEmployment.push(thiss.initaddAnotherApplicantEmployment());
                  }
                });
                thiss.formArrApplicantAddress.push(thiss.initItemApplicantAddressLoad(get_second_user_data[key]));
                thiss.formApplicantIncome.push(thiss.initItemRowsBlank());
                thiss.editgetIncomes(get_second_user_data[key].uid).subscribe((editgetIncomes)=>{
                  let i = 0;
                  if(editgetIncomes.length > 0 && thiss.formApplicantIncome.controls[i].value.itemRows.length == 0){
                    editgetIncomes.forEach(uData => {
                      thiss.formApplicantIncome.controls[key].controls.itemRows.push(thiss.initItemRowsIncomesLoad(uData));
                      i++;
                    })
                  }
                });
                thiss.editgetLiabilities(get_second_user_data[key].uid).subscribe((editgetLiabilities)=>{
                  if(editgetLiabilities.length > 0){
                    let i = 0;
                    editgetLiabilities.forEach(uData => {
                      thiss.formArrLiabilities.push(thiss.initItemRowsLiabilitiesLoad(uData));
                      var getRepayments = thiss.formArrLiabilities.at(i).get('repayments');
                      var type_value = uData.liability_type;
                      if(type_value == 'Commercial Bill' || type_value == 'HECS' || type_value == 'Hire Purchase' || type_value == 'Maintenance' || type_value == 'Outstanding Taxation' || type_value == 'Other'){
                        getRepayments.setValidators(null);
                        getRepayments.updateValueAndValidity();
                      }else{
                        getRepayments.setValidators(Validators.required);
                        getRepayments.updateValueAndValidity();
                      }
                      i++;
                    })
                  }
                });
                thiss.formApplicant.updateValueAndValidity();
                thiss.formApplicantFamily.updateValueAndValidity();
                thiss.formApplicantEmployment.updateValueAndValidity();
                var emp = firebase.firestore().collection("employment").doc(get_second_user_data[key].document_id);
                emp.get().then(function(empDoc) {
                  if (empDoc.exists) {
                  }
                });

                thiss.secondary_details.push(get_second_user_data[key]);
              });
            })
          }, (err) => {
            console.log(err);
          })
        }
      });
    }

    this.slideOneForm = formBuilder.group({
      firstname: ['', Validators.compose([Validators.maxLength(30), Validators.minLength(1), Validators.required])],
      middlename: ['', Validators.compose([Validators.maxLength(30)])],
      lastname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.minLength(10), Validators.required])],
      mobile_phone: ['', Validators.compose([Validators.minLength(12),Validators.maxLength(12), Validators.required])],
      date_of_birth: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary: ['', Validators.compose([Validators.maxLength(30)])],
      primayr_goal_intention: ['', Validators.compose([Validators.required])],
      address_type: ['Home', Validators.compose([Validators.maxLength(30), Validators.required])],
      address_format: ['standard', Validators.compose([Validators.maxLength(30), Validators.required])],
      full_address: [''],
      floor_number: ['', Validators.compose([Validators.maxLength(30)])],
      unit_number: ['', Validators.compose([Validators.maxLength(30)])],
      building_name: ['', Validators.compose([Validators.maxLength(30)])],
      street_number: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      street_name: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      street_type: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      poboxlabel: ['', Validators.compose([Validators.maxLength(30)])],
      city: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      state: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      postcode: ['', Validators.compose([Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.required])],
      country: ['Australia', Validators.compose([Validators.required])],
      housing_situation: ['', Validators.compose([Validators.required])],
      move_in_date: ['', Validators.compose([Validators.required])],
      user_document_id: [''],
      reference_broker: [''],
      addAnotherApplicantItem: this.formBuilder.array([]),
      addPreviousAddressItem: this.formBuilder.array([]),
      addAddressRelationshipItem: this.formBuilder.array([])
    });
    this.slideTwoForm = formBuilder.group({
      gender: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      current_marital_status: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      do_you_have_children: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      how_many_children: [null, [Validators.required]],
      first_child_age: [null, [Validators.required]],
      second_child_age: [null, [Validators.required]],
      third_child_age: [null, [Validators.required]],
      fourth_child_age: [null, [Validators.required]],
      fifth_child_age: [null, [Validators.required]],
      sixth_child_age: [null, [Validators.required]],
      addFamilyItem: formBuilder.array([])
    });
    this.slideThreeForm = formBuilder.group({
      employementType: ['', Validators.required],
      currentlyEmployment: ['', Validators.required],
      expectFindWork: ['', Validators.required],
      statusyourEmployment: ['', Validators.required],
      your_occupation: ['', Validators.required],
      start_date: ['', Validators.required],
      business_name: ['', Validators.required],
      type_of_entity: [''],
      abn_acn: [''],
      nature_of_business: ['', Validators.required],
      addEmploymentItem:  this.formBuilder.array([]),
      addPrimaryEmploymentItem:  this.formBuilder.array([])
    });
    this.slideFourForm = formBuilder.group({
    });
    this.incomeForm = formBuilder.group({
      itemRows: formBuilder.array([]),
      addApplicantIncomeItem: formBuilder.array([])
    });
    this.assetsForm = formBuilder.group({
      itemRowsAssets: formBuilder.array([])
    });
    this.liabilitiesForm = formBuilder.group({
      itemRowsLiabilities: formBuilder.array([])
    });
    this.realEstateForm = formBuilder.group({
      itemRowsRealEstates: formBuilder.array([]),
      itemRowsMortgageSplits: formBuilder.array([])
    });
    this.address_format = 'standard';
    this.selected_type = 'Salary';
    this.getAllBrokers().subscribe((data)=>{
      this.allBrokers = data;
    });
    this.initializeItems();
  }

  ngOnInit() {
    this.signupSlider.autoHeight = true;
    this.setChilderValue();
    this.childrenCount();
    let contact_uidck = window.localStorage.getItem("contact_uid");
    if(contact_uidck == null || contact_uidck == undefined || contact_uidck == ""){}else{
      this.getAllRealEstates(contact_uidck).subscribe((data1)=>{
        if(data1.length > 0){
          this.totalRealEstates = data1;
        }
      });
    }
  }

  initItemRowsPreviousAddress() {
    return this.formBuilder.group({
      addi_same_as_primary: ['true'],
      addi_address_type: ['Home', Validators.compose([Validators.maxLength(30)])],
      addi_address_format: ['standard', Validators.compose([Validators.maxLength(30)])],
      addi_full_address: ['', Validators.compose([Validators.maxLength(30)])],
      addi_floor_number: ['', Validators.compose([Validators.maxLength(30)])],
      addi_unit_number: ['', Validators.compose([Validators.maxLength(30)])],
      addi_building_name: ['', Validators.compose([Validators.maxLength(200)])],
      addi_street_number: ['', Validators.compose([Validators.maxLength(30)])],
      addi_street_name: ['', Validators.compose([Validators.maxLength(30)])],
      addi_street_type: ['', Validators.compose([Validators.maxLength(30)])],
      addi_poboxlabel: ['', Validators.compose([Validators.maxLength(30)])],
      addi_city: ['', Validators.compose([Validators.maxLength(30)])],
      addi_state: ['', Validators.compose([Validators.maxLength(30)])],
      addi_postcode: ['', Validators.compose([Validators.maxLength(30)])],
      addi_country: ['Australia', Validators.compose([Validators.maxLength(30)])],
      addi_housing_situation: ['', Validators.compose([Validators.maxLength(30)])],
      addi_move_out_date: ['', Validators.compose([Validators.maxLength(30)])],
      addi_move_in_date: ['', Validators.compose([Validators.maxLength(30)])],
      document_id: [''],
      deleted: [0]
    });
  }
  initItemApplicantAddress(index) {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      addi_same_as_primary: ['true'],
      addi_address_type: ['Home', Validators.compose([Validators.maxLength(30)])],
      addi_address_format: ['standard', Validators.compose([Validators.maxLength(30)])],
      addi_full_address: ['', Validators.compose([Validators.maxLength(30)])],
      addi_floor_number: ['', Validators.compose([Validators.maxLength(30)])],
      addi_unit_number: ['', Validators.compose([Validators.maxLength(30)])],
      addi_building_name: ['', Validators.compose([Validators.maxLength(200)])],
      addi_street_number: ['', Validators.compose([Validators.maxLength(30)])],
      addi_street_name: ['', Validators.compose([Validators.maxLength(30)])],
      addi_street_type: ['', Validators.compose([Validators.maxLength(30)])],
      addi_poboxlabel: ['', Validators.compose([Validators.maxLength(30)])],
      addi_city: ['', Validators.compose([Validators.maxLength(30)])],
      addi_state: ['', Validators.compose([Validators.maxLength(30)])],
      addi_postcode: ['', Validators.compose([Validators.maxLength(30)])],
      addi_country: ['Australia', Validators.compose([Validators.maxLength(30)])],
      addi_housing_situation: ['', Validators.compose([Validators.maxLength(30)])],
      addi_move_out_date: ['', Validators.compose([Validators.maxLength(30)])],
      addi_move_in_date: ['', Validators.compose([Validators.maxLength(30)])],
      document_id: [''],
      deleted: [0],
      index: index,
      addPAddressRelationshipItem: this.formBuilder.group({
        addPreviousAddressRelationshipItem: this.formBuilder.array([])
      })
    });
  }
  initaddPreviousAddress() {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      previous_address_type: ['Home', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_address_format: ['standard', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_full_address: [''],
      previous_floor_number: ['', Validators.compose([Validators.maxLength(30)])],
      previous_unit_number: ['', Validators.compose([Validators.maxLength(30)])],
      previous_building_name: ['', Validators.compose([Validators.maxLength(30)])],
      previous_poboxlabel: ['', Validators.compose([Validators.maxLength(30)])],
      previous_street_number: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_street_name: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_street_type: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_city: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_state: ['', Validators.compose([Validators.maxLength(30)])],
      previous_postcode: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_country: ['Australia', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_housing_situation: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_move_in_date: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_move_out_date: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0]
    });
  }
  initaddAnotherApplicant() {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      secondary_firstname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_middlename: ['', Validators.compose([Validators.maxLength(30)])],
      secondary_lastname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_email: ['', Validators.compose([Validators.maxLength(100), Validators.required])],
      secondary_mobile_phone: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_date_of_birth: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      relationship_to_primary_applicant: ['Life Partner', Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0],
      uid: [''],
      document_id: ['']
    });
  }
  initaddAnotherApplicantFamily() {
    return this.formBuilder.group({
      gender: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      current_marital_status: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      do_you_have_children: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      how_many_children: [null, [Validators.required]],
      first_child_age: [null, [Validators.required]],
      second_child_age: [null, [Validators.required]],
      third_child_age: [null, [Validators.required]],
      fourth_child_age: [null, [Validators.required]],
      fifth_child_age: [null, [Validators.required]],
      sixth_child_age: [null, [Validators.required]]
    });
  }
  initaddPrimaryEmployment() {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      employementType: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      currentlyEmployment: ['', Validators.compose([Validators.maxLength(30)])],
      statusyourEmployment: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      your_occupation: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      start_date: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      expectFindWork: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      business_name: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      type_of_entity: [''],
      abn_acn: ['', Validators.compose([Validators.maxLength(30)])],
      nature_of_business: ['', Validators.compose([Validators.maxLength(30)])],
      deleted: [0]
    });
  }
  initaddAnotherApplicantEmployment() {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      employementType: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      currentlyEmployment: ['', Validators.compose([Validators.maxLength(30)])],
      statusyourEmployment: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      your_occupation: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      start_date: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      expectFindWork: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      business_name: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      type_of_entity: [''],
      abn_acn: ['', Validators.compose([Validators.maxLength(30)])],
      nature_of_business: ['', Validators.compose([Validators.maxLength(30)])],
      deleted: [0],
      previousEmploymentItem: this.formBuilder.array([])
    });
  }
  initItemRowsBlank() {
    return this.formBuilder.group({
      itemRows: this.formBuilder.array([])
    });
  }
  initItemRows() {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      type: ['Salary', Validators.compose([Validators.maxLength(30), Validators.required])],
      amount: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      receive_overtime: ['', Validators.compose([Validators.maxLength(30)])],
      receive_commissions_bounses: ['', Validators.compose([Validators.maxLength(30)])],
      receive_moter_vehicle_allowance: ['', Validators.compose([Validators.maxLength(30)])],
      salary_sacrifice: ['', Validators.compose([Validators.maxLength(30)])],
      any_other_allowances: ['', Validators.compose([Validators.maxLength(30)])],
      frequency: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      date_commenced: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      comments: [''],
      sallary_payslip_0: [''],
      sallary_payslip_1: [''],
      sallary_payslip_2: [''],
      sallary_payslip_3: [''],
      sallary_payslip_4: [''],
      sallary_payslip_5: [''],
      sallary_payslip_name_0: [''],
      sallary_payslip_name_1: [''],
      sallary_payslip_name_2: [''],
      sallary_payslip_name_3: [''],
      sallary_payslip_name_4: [''],
      sallary_payslip_name_5: [''],
      document_id: [''],
      deleted: [0]
    });
  }
  initItemRowsAssets() {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      asset_type: ['Boat', Validators.compose([Validators.maxLength(30), Validators.required])],
      asset_value: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      value_basis: ['Applicant Estimate', Validators.compose([Validators.maxLength(30), Validators.required])],
      percentage_asset: ['', Validators.compose([Validators.required, Validators.min(0), Validators.max(100)])],
      percentage_asset_0: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      percentage_asset_1: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      percentage_asset_2: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      percentage_asset_3: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      percentage_asset_4: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      institution: ['', Validators.compose([Validators.maxLength(30)])],
      account_name: ['', Validators.compose([Validators.maxLength(200)])],
      bsb: ['', Validators.compose([Validators.maxLength(30)])],
      account_no: ['', Validators.compose([Validators.maxLength(30)])],
      type: ['', Validators.compose([Validators.maxLength(30)])],
      year: ['', Validators.compose([Validators.maxLength(30)])],
      make: ['', Validators.compose([Validators.maxLength(30)])],
      description: [''],
      document_id: [''],
      deleted: [0]
    });
  }
  initItemRowsLiabilities() {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      liability_type: ['Commercial Bill', Validators.compose([Validators.maxLength(30), Validators.required])],
      current_balance: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      limit: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      credit_cart_type: ['', Validators.compose([Validators.maxLength(30)])],
      institution: ['', Validators.compose([Validators.maxLength(30)])],
      account_name: ['', Validators.compose([Validators.maxLength(200)])],
      bsb: ['', Validators.compose([Validators.maxLength(30)])],
      account_no: ['', Validators.compose([Validators.maxLength(30)])],
      clearing_from_this_loan: [''],
      owner: [''],
      repayments: ['', Validators.compose([Validators.maxLength(30)])],
      payment_type: ['', Validators.compose([Validators.maxLength(30)])],
      description: [''],
      document_id: [''],
      deleted: [0]
    });
  }
  initItemRowsRealEstate() {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      asset_type: ['Real Estate', Validators.compose([Validators.maxLength(30), Validators.required])],
      asset_value: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      value_basis: ['Applicant Estimate', Validators.compose([Validators.maxLength(30), Validators.required])],
      ownership_title_name: ['', Validators.compose([Validators.required, Validators.maxLength(200)])],
      primary_percentage_asset: ['', Validators.compose([Validators.required, Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_0: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_1: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_2: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_3: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_4: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      notes: [''],
      address_format: ['standard', Validators.compose([Validators.required, Validators.maxLength(30)])],
      full_address: [''],
      floor_number: ['', Validators.compose([Validators.maxLength(30)])],
      unit_number: ['', Validators.compose([Validators.maxLength(30)])],
      building_name: ['', Validators.compose([Validators.maxLength(30)])],
      street_number: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      street_name: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      street_type: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      city: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      state: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      postcode: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      country: ['Australia', Validators.compose([Validators.required, Validators.maxLength(30)])],
      gross_amount: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      document_id: [''],
      deleted: [0],
      itemRowsMortgageSplits: this.formBuilder.array([this.initItemRowsRealEstateSplit()])
    });
  }

  initItemRowsRealEstateSplit() {
    return this.formBuilder.group({
        creditor: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
        available_redraw: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
        mortgage_limit: [''],
        current_balance: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
        loan_type: ['Interest Only Loan', Validators.compose([Validators.required, Validators.maxLength(30)])],
        repayments: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
        interest_rate: ['', Validators.compose([Validators.required, Validators.maxLength(30), Validators.min(1), Validators.max(100)])],
        interest_rate_term: ['Fixed', Validators.compose([Validators.required, Validators.maxLength(30)])],
        document_id: [''],
        deleted: [0]
      });
  }
  initItemRowsMortgageSplit() {
    return this.formBuilder.group({
      creditor: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      available_redraw: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      current_balance: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      mortgage_limit: [''],
      loan_type: ['Interest Only Loan', Validators.compose([Validators.required, Validators.maxLength(30)])],
      repayments: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      interest_rate: ['', Validators.compose([Validators.required, Validators.maxLength(30), Validators.min(1), Validators.max(100)])],
      interest_rate_term: ['Fixed', Validators.compose([Validators.required, Validators.maxLength(30)])],
      document_id: [''],
      deleted: [0]
    });
  }
  initaddPreviousAddressLoad(data) {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      previous_address_type: [data.previous_address_type, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_address_format: [data.previous_address_format, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_full_address: [''],
      previous_floor_number: ['', Validators.compose([Validators.maxLength(30)])],
      previous_unit_number: ['', Validators.compose([Validators.maxLength(30)])],
      previous_building_name: ['', Validators.compose([Validators.maxLength(30)])],
      previous_poboxlabel: ['', Validators.compose([Validators.maxLength(30)])],
      previous_street_number: [data.previous_street_number, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_street_name: [data.previous_street_name, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_street_type: [data.previous_street_type, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_city: [data.previous_city, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_state: [data.previous_state, Validators.compose([Validators.maxLength(30)])],
      previous_postcode: [data.previous_postcode, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_country: [data.previous_country, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_housing_situation: [data.previous_housing_situation, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_move_in_date: [data.previous_move_in_date, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_move_out_date: [data.previous_move_out_date, Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0]
    });
  }
  initItemRowsApplicantLoad(data) {
    return this.formBuilder.group({
      secondary_firstname: [data.firstname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_middlename: [data.middlename, Validators.compose([Validators.maxLength(30)])],
      secondary_lastname: [data.lastname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_email: [data.email, Validators.compose([Validators.maxLength(100), Validators.required])],
      secondary_mobile_phone: [data.mobile_phone, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_date_of_birth: [data.date_of_birth, Validators.compose([Validators.maxLength(30), Validators.required])],
      relationship_to_primary_applicant: [(data.relationship_to_primary_applicant == "" || data.relationship_to_primary_applicant == null || data.relationship_to_primary_applicant == undefined) ? 'Life Partner' : data.relationship_to_primary_applicant, Validators.compose([Validators.maxLength(100), Validators.required])],
      deleted: [0],
      uid: [data.uid],
      document_id: [data.document_id]
    });
  }
  initItemApplicantAddressLoad(data) {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      addi_same_as_primary: [(data.same_as_primary == undefined && data.city == "") ? 'true' : data.same_as_primary],
      addi_address_type: [data.address_type, Validators.compose([Validators.maxLength(30)])],
      addi_address_format: [data.address_format, Validators.compose([Validators.maxLength(30)])],
      addi_full_address: ['', Validators.compose([Validators.maxLength(30)])],
      addi_floor_number: [data.floor_number, Validators.compose([Validators.maxLength(30)])],
      addi_unit_number: [data.unit_number, Validators.compose([Validators.maxLength(30)])],
      addi_building_name: [data.building_name, Validators.compose([Validators.maxLength(200)])],
      addi_street_number: [data.street_number, Validators.compose([Validators.maxLength(30)])],
      addi_street_name: [data.street_name, Validators.compose([Validators.maxLength(30)])],
      addi_street_type: [data.street_type, Validators.compose([Validators.maxLength(30)])],
      addi_poboxlabel: [data.poboxlabel, Validators.compose([Validators.maxLength(30)])],
      addi_city: [data.city, Validators.compose([Validators.maxLength(30)])],
      addi_state: [data.state, Validators.compose([Validators.maxLength(30)])],
      addi_postcode: [data.postcode, Validators.compose([Validators.maxLength(30)])],
      addi_country: [data.country, Validators.compose([Validators.maxLength(30)])],
      addi_housing_situation: [data.housing_situation, Validators.compose([Validators.maxLength(30)])],
      addi_move_in_date: [data.move_in_date, Validators.compose([Validators.maxLength(30)])],
      document_id: [data.document_id],
      deleted: [0],
      addPAddressRelationshipItem: this.formBuilder.group({
        addPreviousAddressRelationshipItem: this.formBuilder.array([])
      })
    });
  }
  initaddAnotherApplicantFamilyLoad(data) {
    return this.formBuilder.group({
      gender: [data.gender, Validators.compose([Validators.maxLength(30), Validators.required])],
      current_marital_status: [data.current_marital_status, Validators.compose([Validators.maxLength(30), Validators.required])],
      do_you_have_children: [data.do_you_have_children, Validators.compose([Validators.maxLength(30), Validators.required])],
      how_many_children: [data.how_many_children, (data.how_many_children > 0) ? [Validators.required] : ''],
      first_child_age: [data.first_child_age, (data.first_child_age > 0) ? [Validators.required] : ''],
      second_child_age: [data.second_child_age, (data.second_child_age > 0) ? [Validators.required] : ''],
      third_child_age: [data.third_child_age, (data.third_child_age > 0) ? [Validators.required] : ''],
      fourth_child_age: [data.fourth_child_age, (data.fourth_child_age > 0) ? [Validators.required] : ''],
      fifth_child_age: [data.fifth_child_age, (data.fifth_child_age > 0) ? [Validators.required] : ''],
      sixth_child_age: [data.sixth_child_age, (data.sixth_child_age > 0) ? [Validators.required] : '']
    });
  }
  initaddPrimaryEmploymentLoad(data) {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      employementType: [data.employementType, Validators.compose([Validators.maxLength(30), Validators.required])],
      currentlyEmployment: [data.currentlyEmployment, Validators.compose([Validators.maxLength(30)])],
      statusyourEmployment: [data.statusyourEmployment, Validators.compose([Validators.maxLength(30), Validators.required])],
      your_occupation: [data.your_occupation, Validators.compose([Validators.maxLength(30), Validators.required])],
      start_date: [data.start_date, Validators.compose([Validators.maxLength(30), Validators.required])],
      expectFindWork: [data.expectFindWork, Validators.compose([Validators.maxLength(30), Validators.required])],
      business_name: [data.business_name, Validators.compose([Validators.maxLength(30), Validators.required])],
      type_of_entity: [data.type_of_entity],
      abn_acn: [data.abn_acn, Validators.compose([Validators.maxLength(30)])],
      nature_of_business: [data.nature_of_business, Validators.compose([Validators.maxLength(30)])]
    });
  }
  initaddAnotherApplicantEmploymentLoad(data) {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      employementType: [data.employementType, Validators.compose([Validators.maxLength(30), Validators.required])],
      currentlyEmployment: [data.currentlyEmployment, Validators.compose([Validators.maxLength(30)])],
      statusyourEmployment: [data.statusyourEmployment, Validators.compose([Validators.maxLength(30), Validators.required])],
      your_occupation: [data.your_occupation, Validators.compose([Validators.maxLength(30), Validators.required])],
      start_date: [data.start_date, Validators.compose([Validators.maxLength(30), Validators.required])],
      expectFindWork: [data.expectFindWork, Validators.compose([Validators.maxLength(30), Validators.required])],
      business_name: [data.business_name, Validators.compose([Validators.maxLength(30), Validators.required])],
      type_of_entity: [data.type_of_entity],
      abn_acn: [data.abn_acn, Validators.compose([Validators.maxLength(30)])],
      nature_of_business: [data.nature_of_business, Validators.compose([Validators.maxLength(30)])],
      deleted: [0],
      uid: [data.uid],
      document_id: [data.document_id],
      previousEmploymentItem: this.formBuilder.array([])
    });
  }
  initItemRowsIncomesLoad(data) {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      type: [data.type, Validators.compose([Validators.required, Validators.maxLength(30), Validators.required])],
      amount: [data.amount, Validators.compose([Validators.maxLength(30), Validators.required])],
      receive_overtime: [data.receive_overtime, Validators.compose([Validators.maxLength(30)])],
      receive_commissions_bounses: [data.receive_commissions_bounses, Validators.compose([Validators.maxLength(30)])],
      receive_moter_vehicle_allowance: [data.receive_moter_vehicle_allowance, Validators.compose([Validators.maxLength(30)])],
      salary_sacrifice: [data.salary_sacrifice, Validators.compose([Validators.maxLength(30)])],
      any_other_allowances: [data.any_other_allowances, Validators.compose([Validators.maxLength(30)])],
      frequency: [data.frequency, Validators.compose([Validators.maxLength(30), Validators.required])],
      date_commenced: [data.date_commenced, Validators.compose([Validators.maxLength(30), Validators.required])],
      comments: [data.comments],
      sallary_payslip_0: [data.sallary_payslip_0],
      sallary_payslip_1: [data.sallary_payslip_1],
      sallary_payslip_2: [data.sallary_payslip_2],
      sallary_payslip_3: [data.sallary_payslip_3],
      sallary_payslip_4: [data.sallary_payslip_4],
      sallary_payslip_5: [data.sallary_payslip_5],
      sallary_payslip_name_0: [data.sallary_payslip_name_0],
      sallary_payslip_name_1: [data.sallary_payslip_name_1],
      sallary_payslip_name_2: [data.sallary_payslip_name_2],
      sallary_payslip_name_3: [data.sallary_payslip_name_3],
      sallary_payslip_name_4: [data.sallary_payslip_name_4],
      sallary_payslip_name_5: [data.sallary_payslip_name_5],
      document_id: [data.document_id],
      deleted: [data.deleted]
    });
  }
  initItemRowsAssetsLoad(data) {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      asset_type: [data.asset_type, Validators.compose([Validators.maxLength(30), Validators.required])],
      asset_value: [data.asset_value, Validators.compose([Validators.maxLength(30), Validators.required])],
      value_basis: [data.value_basis, Validators.compose([Validators.maxLength(30), Validators.required])],
      percentage_asset: [(data.percentage_asset == "" || data.percentage_asset == null || data.percentage_asset == undefined) ? 0 : data.percentage_asset, Validators.compose([Validators.required, Validators.min(0), Validators.max(100)])],
      percentage_asset_0: [data.percentage_asset_0, Validators.compose([Validators.min(0), Validators.max(100)])],
      percentage_asset_1: [data.percentage_asset_1, Validators.compose([Validators.min(0), Validators.max(100)])],
      percentage_asset_2: [data.percentage_asset_2, Validators.compose([Validators.min(0), Validators.max(100)])],
      percentage_asset_3: [data.percentage_asset_3, Validators.compose([Validators.min(0), Validators.max(100)])],
      percentage_asset_4: [data.percentage_asset_4, Validators.compose([Validators.min(0), Validators.max(100)])],
      institution: [data.institution, Validators.compose([Validators.maxLength(30)])],
      account_name: [data.account_name, Validators.compose([Validators.maxLength(200)])],
      bsb: [data.bsb, Validators.compose([Validators.maxLength(30)])],
      account_no: [data.account_no, Validators.compose([Validators.maxLength(30)])],
      type: [data.type, Validators.compose([Validators.maxLength(30)])],
      year: [data.year, Validators.compose([Validators.maxLength(30)])],
      make: [data.make, Validators.compose([Validators.maxLength(30)])],
      description: [data.description],
      document_id: [data.document_id],
      deleted: [data.deleted]
    });
  }
  initItemRowsLiabilitiesLoad(data) {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      liability_type: [data.liability_type, Validators.compose([Validators.maxLength(30), Validators.required])],
      current_balance: [data.current_balance, Validators.compose([Validators.maxLength(30), Validators.required])],
      limit: [data.limit, Validators.compose([Validators.maxLength(30), Validators.required])],
      credit_cart_type: [data.credit_cart_type, Validators.compose([Validators.maxLength(30)])],
      institution: [data.institution, Validators.compose([Validators.maxLength(30)])],
      account_name: [data.account_name, Validators.compose([Validators.maxLength(200)])],
      bsb: [data.bsb, Validators.compose([Validators.maxLength(30)])],
      account_no: [data.account_no, Validators.compose([Validators.maxLength(30)])],
      clearing_from_this_loan: [data.clearing_from_this_loan],
      repayments: [data.repayments, Validators.compose([Validators.maxLength(30)])],
      payment_type: [data.payment_type, Validators.compose([Validators.maxLength(30)])],
      description: [data.description],
      owner: [data.uid],
      document_id: [data.document_id],
      deleted: [data.deleted]
    });
  }
  initItemRowsRealEstatesLoad(data) {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      asset_type: [data.asset_type, Validators.compose([Validators.maxLength(30), Validators.required])],
      asset_value: [data.asset_value, Validators.compose([Validators.maxLength(30), Validators.required])],
      value_basis: ['Applicant Estimate', Validators.compose([Validators.maxLength(30), Validators.required])],
      ownership_title_name: [data.ownership_title_name, Validators.compose([Validators.required, Validators.maxLength(200)])],
      primary_percentage_asset: [data.primary_percentage_asset, Validators.compose([Validators.required, Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_0: [data.secondary_percentage_asset_0, Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_1: [data.secondary_percentage_asset_1, Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_2: [data.secondary_percentage_asset_2, Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_3: [data.secondary_percentage_asset_3, Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_4: [data.secondary_percentage_asset_4, Validators.compose([Validators.min(0), Validators.max(100)])],
      notes: [data.notes],
      address_format: [data.address_format, Validators.compose([Validators.required, Validators.maxLength(30)])],
      full_address: [''],
      floor_number: [data.floor_number, Validators.compose([Validators.maxLength(30)])],
      unit_number: [data.unit_number, Validators.compose([Validators.maxLength(30)])],
      building_name: [data.building_name, Validators.compose([Validators.maxLength(30)])],
      street_number: [data.street_number, Validators.compose([Validators.required, Validators.maxLength(30)])],
      street_name: [data.street_name, Validators.compose([Validators.required, Validators.maxLength(30)])],
      street_type: [data.street_type, Validators.compose([Validators.required, Validators.maxLength(30)])],
      city: [data.city, Validators.compose([Validators.required, Validators.maxLength(30)])],
      state: [data.state, Validators.compose([Validators.required, Validators.maxLength(30)])],
      postcode: [data.postcode, Validators.compose([Validators.required, Validators.maxLength(30)])],
      country: [data.country, Validators.compose([Validators.required, Validators.maxLength(30)])],
      gross_amount: [data.gross_amount, Validators.compose([Validators.required, Validators.maxLength(30)])],
      document_id: [data.document_id],
      deleted: [data.deleted],
      itemRowsMortgageSplits: this.formBuilder.array([this.initItemRowsRealEstateSplit()])
    });
  }

  initItemRowsMortgageSplitLoad(data) {
    return this.formBuilder.group({
      creditor: [data.creditor, Validators.compose([Validators.required, Validators.maxLength(30)])],
      available_redraw: [data.available_redraw, Validators.compose([Validators.required, Validators.maxLength(30)])],
      mortgage_limit: [data.mortgage_limit],
      current_balance: [data.current_balance, Validators.compose([Validators.required, Validators.maxLength(30)])],
      loan_type: [data.loan_type, Validators.compose([Validators.required, Validators.maxLength(30)])],
      repayments: [data.repayments, Validators.compose([Validators.required, Validators.maxLength(30)])],
      interest_rate: [data.interest_rate, Validators.compose([Validators.required, Validators.maxLength(30), Validators.min(1), Validators.max(100)])],
      interest_rate_term: [data.interest_rate_term, Validators.compose([Validators.required, Validators.maxLength(30)])],
      document_id: [data.document_id],
      deleted: [0]
    });
  }

  getAllBrokers (){
    return this.db.collection<any>( "users" , ref => ref.where('roles.broker','==',true )).valueChanges ();
  }
  editgetAllassets (edit_contact_uid){
    if(this.userRole == "super_admin" && this.deleted_access == 1){
      return this.db.collection<any>( "SDF_assets", ref => ref.where('uid','==',edit_contact_uid )).valueChanges ();
    }else{
      return this.db.collection<any>( "SDF_assets", ref => ref.where('uid','==',edit_contact_uid ).where('deleted','==',0 )).valueChanges ();
    }
  }
  editgetAllliabilities (edit_contact_uid){
    if(this.userRole == "super_admin" && this.deleted_access == 1){
      return this.db.collection<any>( "SDF_liabilities", ref => ref.where('uid','==',edit_contact_uid )).valueChanges ();
    }else{
      return this.db.collection<any>( "SDF_liabilities", ref => ref.where('uid','==',edit_contact_uid ).where('deleted','==',0 )).valueChanges ();
    }
  }
  editgetIncome (edit_contact_uid){
    if(this.userRole == "super_admin" && this.deleted_access == 1){
      return this.db.collection<any>( "SDF_income", ref => ref.where('uid','==',edit_contact_uid )).valueChanges ();
    }else{
      return this.db.collection<any>( "SDF_income", ref => ref.where('uid','==',edit_contact_uid ).where('deleted','==',0 )).valueChanges ();
    }
  }
  editgetSDFUser (SDF_form_document_id, uid){
    if(this.userRole == "super_admin" && this.deleted_access == 1){
      return this.db.collection<any>( "users_data", ref => ref.where('created_date','>',0 ).where('SDF_form_document_id','==',SDF_form_document_id ).where('uid','==',uid ).orderBy('created_date', 'asc')).valueChanges ();
    }else{
      return this.db.collection<any>( "users_data", ref => ref.where('created_date','>',0 ).where('SDF_form_document_id','==',SDF_form_document_id ).where('uid','==',uid ).where('deleted','==',0 ).orderBy('created_date', 'asc')).valueChanges ();
    }
  }
  // get_second_user_data (SDF_form_document_id){
  //   return this.db.collection<any>( "users_data" , ref => ref.where('created_date','>',0 ).where('contact_type','==','Secondary Contact').where('SDF_form_document_id','==',SDF_form_document_id).where('deleted','==',0 ).orderBy('created_date', 'asc')).valueChanges ();
  // }
  editgetSDFEmployment (SDF_form_document_id, uid){
    if(this.userRole == "super_admin" && this.deleted_access == 1){
      return this.db.collection<any>( "employment", ref => ref.where('created_date','>',0 ).where('SDF_form_document_id','==',SDF_form_document_id ).where('uid','==',uid )).valueChanges ();
    }else{
      return this.db.collection<any>( "employment", ref => ref.where('created_date','>',0 ).where('SDF_form_document_id','==',SDF_form_document_id ).where('uid','==',uid ).where('deleted','==',0 )).valueChanges ();
    }
  }
  editgetIncomes (uid){
    if(this.userRole == "super_admin" && this.deleted_access == 1){
      return this.db.collection<any>( "SDF_income", ref => ref.where('created_date','>',0 ).where('uid','==',uid )).valueChanges ();
    }else{
      return this.db.collection<any>( "SDF_income", ref => ref.where('created_date','>',0 ).where('uid','==',uid ).where('deleted','==',0 )).valueChanges ();
    }
  }
  editgetassets (SDF_form_document_id){
    if(this.userRole == "super_admin" && this.deleted_access == 1){
      return this.db.collection<any>( "SDF_assets", ref => ref.where('created_date','>',0 ).where('SDF_form','==',SDF_form_document_id )).valueChanges ();
    }else{
      return this.db.collection<any>( "SDF_assets", ref => ref.where('created_date','>',0 ).where('SDF_form','==',SDF_form_document_id ).where('deleted','==',0 )).valueChanges ();
    }
  }
  editgetLiabilities (uid){
    if(this.userRole == "super_admin" && this.deleted_access == 1){
      return this.db.collection<any>( "SDF_liabilities", ref => ref.where('created_date','>',0 ).where('uid','==',uid )).valueChanges ();
    }else{
      return this.db.collection<any>( "SDF_liabilities", ref => ref.where('created_date','>',0 ).where('uid','==',uid ).where('deleted','==',0 )).valueChanges ();
    }
  }
  editgetRealEstate (SDF_form_document_id){
    if(this.userRole == "super_admin" && this.deleted_access == 1){
      return this.db.collection<any>( "SDF_realestate", ref => ref.where('created_date','>',0 ).where('SDF_form','==',SDF_form_document_id )).valueChanges ();
    }else{
      return this.db.collection<any>( "SDF_realestate", ref => ref.where('created_date','>',0 ).where('SDF_form','==',SDF_form_document_id ).where('deleted','==',0 )).valueChanges ();
    }
  }
  editgetRealEstateSplit (mortgage_split_id){
    if(this.userRole == "super_admin" && this.deleted_access == 1){
      return this.db.collection<any>( "SDF_realestate/"+mortgage_split_id+"/mortgage_splits", ref => ref.orderBy('created_date' ) ).valueChanges ();
    }else{
      return this.db.collection<any>( "SDF_realestate/"+mortgage_split_id+"/mortgage_splits", ref => ref.where('deleted', '<', 1 ) ).valueChanges ();
    }
  }
  editgetAllAdditionalApplicant(secondary_uid){
    return this.db.collection<any>( "users", ref => ref.where('uid','==',secondary_uid ).where('deleted','==',0 )).valueChanges ();
  }
  getAllInomces (contact_uid){
    return this.db.collection<any>( "SDF_income" , ref => ref.where('uid','==',contact_uid ).where('deleted','<',1)).valueChanges ();
  }
  getAllRealEstates (contact_uid){
    return this.db.collection<any>( "SDF_realestate" , ref => ref.where('primary_uid','==',contact_uid ).where('deleted','<',1)).valueChanges ();
  }

  additional_applicant_show(secondary_uid){
    this.editgetAllAdditionalApplicant(secondary_uid).subscribe((data)=>{
      if(data.length > 0 && this.formApplicant.length == 0){
        this.allSecApplicant = data;
        for(let i = 0; i < this.allSecApplicant.length; i++){
          this.formApplicant.push(this.initItemRowsApplicantLoad(this.allSecApplicant[i]));
        }
        this.formApplicant.updateValueAndValidity();
        this.formApplicant.updateValueAndValidity();
      }else{
        this.allSecApplicant = [];
      }
      this.signupSlider.resize();
      this.signupSlider.update();
    });
  }

  childrenCount(){
    let howManyChildren = this.slideTwoForm.get('how_many_children');
    let firstChild = this.slideTwoForm.get('first_child_age');
    let secondChild = this.slideTwoForm.get('second_child_age');
    let thirdChild = this.slideTwoForm.get('third_child_age');
    let forthChild = this.slideTwoForm.get('fourth_child_age');
    let fifthChild = this.slideTwoForm.get('fifth_child_age');
    let sixthChild = this.slideTwoForm.get('sixth_child_age');
    howManyChildren.valueChanges
    .subscribe(child =>{
      if(child == 0){
        secondChild.setValidators(null);
        thirdChild.setValidators(null);
        forthChild.setValidators(null);
        fifthChild.setValidators(null);
        sixthChild.setValidators(null);
        firstChild.setValidators(null);
      }
      if(child == 1){
        secondChild.setValidators(null);
        thirdChild.setValidators(null);
        forthChild.setValidators(null);
        fifthChild.setValidators(null);
        sixthChild.setValidators(null);
        firstChild.setValidators(Validators.required);
      }
      if(child == 2){
        thirdChild.setValidators(null);
        forthChild.setValidators(null);
        fifthChild.setValidators(null);
        sixthChild.setValidators(null);
        firstChild.setValidators(Validators.required);
        secondChild.setValidators(Validators.required);
      }
      if(child == 3){
        forthChild.setValidators(null);
        fifthChild.setValidators(null);
        sixthChild.setValidators(null);
        firstChild.setValidators(Validators.required);
        secondChild.setValidators(Validators.required);
        thirdChild.setValidators(Validators.required);
      }
      if(child == 4){
        fifthChild.setValidators(null);
        sixthChild.setValidators(null);
        firstChild.setValidators(Validators.required);
        secondChild.setValidators(Validators.required);
        thirdChild.setValidators(Validators.required);
        forthChild.setValidators(Validators.required);
      }
      if(child == 5){
        sixthChild.setValidators(null);
        firstChild.setValidators(Validators.required);
        secondChild.setValidators(Validators.required);
        thirdChild.setValidators(Validators.required);
        forthChild.setValidators(Validators.required);
        fifthChild.setValidators(Validators.required);
      }
      if( child == 6){
        firstChild.setValidators(Validators.required);
        secondChild.setValidators(Validators.required);
        thirdChild.setValidators(Validators.required);
        forthChild.setValidators(Validators.required);
        fifthChild.setValidators(Validators.required);
        sixthChild.setValidators(Validators.required);
      }
      firstChild.updateValueAndValidity();
      secondChild.updateValueAndValidity();
      thirdChild.updateValueAndValidity();
      forthChild.updateValueAndValidity();
      fifthChild.updateValueAndValidity();
      sixthChild.updateValueAndValidity();
    });
    this.signupSlider.resize();
    this.signupSlider.update();
  }

  secondaryChildrenCount(index){
    let child = this.formApplicantFamily.controls[index].get('how_many_children').value;
    let firstChild = this.formApplicantFamily.controls[index].get('first_child_age');
    let secondChild = this.formApplicantFamily.controls[index].get('second_child_age');
    let thirdChild = this.formApplicantFamily.controls[index].get('third_child_age');
    let forthChild = this.formApplicantFamily.controls[index].get('fourth_child_age');
    let fifthChild = this.formApplicantFamily.controls[index].get('fifth_child_age');
    let sixthChild = this.formApplicantFamily.controls[index].get('sixth_child_age');
    if(child == 0){
      secondChild.setValidators(null);
      thirdChild.setValidators(null);
      forthChild.setValidators(null);
      fifthChild.setValidators(null);
      sixthChild.setValidators(null);
      firstChild.setValidators(null);
    }
    if(child == 1){
      secondChild.setValidators(null);
      thirdChild.setValidators(null);
      forthChild.setValidators(null);
      fifthChild.setValidators(null);
      sixthChild.setValidators(null);
      firstChild.setValidators(Validators.required);
    }
    if(child == 2){
      thirdChild.setValidators(null);
      forthChild.setValidators(null);
      fifthChild.setValidators(null);
      sixthChild.setValidators(null);
      firstChild.setValidators(Validators.required);
      secondChild.setValidators(Validators.required);
    }
    if(child == 3){
      forthChild.setValidators(null);
      fifthChild.setValidators(null);
      sixthChild.setValidators(null);
      firstChild.setValidators(Validators.required);
      secondChild.setValidators(Validators.required);
      thirdChild.setValidators(Validators.required);
    }
    if(child == 4){
      fifthChild.setValidators(null);
      sixthChild.setValidators(null);
      firstChild.setValidators(Validators.required);
      secondChild.setValidators(Validators.required);
      thirdChild.setValidators(Validators.required);
      forthChild.setValidators(Validators.required);
    }
    if(child == 5){
      sixthChild.setValidators(null);
      firstChild.setValidators(Validators.required);
      secondChild.setValidators(Validators.required);
      thirdChild.setValidators(Validators.required);
      forthChild.setValidators(Validators.required);
      fifthChild.setValidators(Validators.required);
    }
    if( child == 6){
      firstChild.setValidators(Validators.required);
      secondChild.setValidators(Validators.required);
      thirdChild.setValidators(Validators.required);
      forthChild.setValidators(Validators.required);
      fifthChild.setValidators(Validators.required);
      sixthChild.setValidators(Validators.required);
    }
    firstChild.updateValueAndValidity();
    secondChild.updateValueAndValidity();
    thirdChild.updateValueAndValidity();
    forthChild.updateValueAndValidity();
    fifthChild.updateValueAndValidity();
    sixthChild.updateValueAndValidity();

    this.signupSlider.resize();
    this.signupSlider.update();
  }

  setChilderValue(){
    let howManyChildren = this.slideTwoForm.get('how_many_children');
    let firstChild = this.slideTwoForm.get('first_child_age');
    let secondChild = this.slideTwoForm.get('second_child_age');
    let thirdChild = this.slideTwoForm.get('third_child_age');
    let forthChild = this.slideTwoForm.get('fourth_child_age');
    let fifthChild = this.slideTwoForm.get('fifth_child_age');
    let sixthChild = this.slideTwoForm.get('sixth_child_age');
    this.slideTwoForm.get('do_you_have_children').valueChanges
    .subscribe(hasChild => {
      if(hasChild == 'No'){
        howManyChildren.setValidators(null);
        firstChild.setValidators(null);
        secondChild.setValidators(null);
        thirdChild.setValidators(null);
        forthChild.setValidators(null);
        fifthChild.setValidators(null);
        sixthChild.setValidators(null);
      }
      if(hasChild == 'Yes'){
        howManyChildren.setValue(null);
        howManyChildren.setValidators(Validators.required);
        firstChild.setValue(null);
        secondChild.setValue(null);
        thirdChild.setValue(null);
        forthChild.setValue(null);
        fifthChild.setValue(null);
        sixthChild.setValue(null);
      }
      howManyChildren.updateValueAndValidity();
      firstChild.updateValueAndValidity();
      secondChild.updateValueAndValidity();
      thirdChild.updateValueAndValidity();
      forthChild.updateValueAndValidity();
      fifthChild.updateValueAndValidity();
      sixthChild.updateValueAndValidity();
    });
    this.signupSlider.resize();
    this.signupSlider.update();
  }

  setSecondaryChilderValue(index){
    let hasChild = this.formApplicantFamily.controls[index].get('do_you_have_children').value;
    let howManyChildren = this.formApplicantFamily.controls[index].get('how_many_children');
    let firstChild = this.formApplicantFamily.controls[index].get('first_child_age');
    let secondChild = this.formApplicantFamily.controls[index].get('second_child_age');
    let thirdChild = this.formApplicantFamily.controls[index].get('third_child_age');
    let forthChild = this.formApplicantFamily.controls[index].get('fourth_child_age');
    let fifthChild = this.formApplicantFamily.controls[index].get('fifth_child_age');
    let sixthChild = this.formApplicantFamily.controls[index].get('sixth_child_age');
    if(hasChild == 'No'){
      howManyChildren.setValidators(null);
      firstChild.setValidators(null);
      secondChild.setValidators(null);
      thirdChild.setValidators(null);
      forthChild.setValidators(null);
      fifthChild.setValidators(null);
      sixthChild.setValidators(null);
    }
    if(hasChild == 'Yes'){
      howManyChildren.setValue(null);
      howManyChildren.setValidators(Validators.required);
      firstChild.setValue(null);
      secondChild.setValue(null);
      thirdChild.setValue(null);
      forthChild.setValue(null);
      fifthChild.setValue(null);
      sixthChild.setValue(null);
    }
    howManyChildren.updateValueAndValidity();
    firstChild.updateValueAndValidity();
    secondChild.updateValueAndValidity();
    thirdChild.updateValueAndValidity();
    forthChild.updateValueAndValidity();
    fifthChild.updateValueAndValidity();
    sixthChild.updateValueAndValidity();

    this.signupSlider.resize();
    this.signupSlider.update();
  }

  public changeAddressFormat($event, index, types){
    let streetNumber = this.slideOneForm.get('street_number');
    let streetName = this.slideOneForm.get('street_name');
    let streetType = this.slideOneForm.get('street_type');
    if(types == 'primary_address'){
      this.address_format = $event;
      streetNumber = this.slideOneForm.get('street_number');
      streetName = this.slideOneForm.get('street_name');
      streetType = this.slideOneForm.get('street_type');
    }else if(types == 'primary_previous'){
      streetNumber = this.slideOneForm.controls.addPreviousAddressItem['controls'][index].get('previous_street_number');
      streetName = this.slideOneForm.controls.addPreviousAddressItem['controls'][index].get('previous_street_name');
      streetType = this.slideOneForm.controls.addPreviousAddressItem['controls'][index].get('previous_street_type');
    }else if(types == 'secondary_address'){
      streetNumber = this.slideOneForm.controls.addAddressRelationshipItem['controls'][index].get('addi_street_number');
      streetName = this.slideOneForm.controls.addAddressRelationshipItem['controls'][index].get('addi_street_name');
      streetType = this.slideOneForm.controls.addAddressRelationshipItem['controls'][index].get('addi_street_type');
    }
    if($event == 'nonStandard'){
      streetNumber.setValidators(Validators.required);
      streetName.setValidators(Validators.required);
      streetType.setValidators(Validators.required);
    }else if($event == 'poBox'){
      streetNumber.setValidators(null);
      streetName.setValidators(null);
      streetType.setValidators(null);
    }else{
      streetNumber.setValidators(Validators.required);
      streetName.setValidators(Validators.required);
      streetType.setValidators(Validators.required);
    }
    streetNumber.updateValueAndValidity();
    streetName.updateValueAndValidity();
    streetType.updateValueAndValidity();
    this.signupSlider.resize();
    this.signupSlider.update();

    this.new_val = event;
    this.old_val = '';
    var property = '';
    if(types == 'address_format'){
      if(this.allRealEstatess.length > index){
        this.old_val = this.allRealEstatess[index].address_format;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Address Format';
    }
    if(this.new_val != this.old_val && property != ""){
      this.realEstate_details.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index' : index});
    }
    this.realEstate_details.sort((a,b)=>a.index > b.index);

  }

  public changePreviousAddressFormat($event, index){
    let streetNumber = this.slideOneForm.controls.addPreviousAddressItem['controls'][index].get('previous_street_number');
    let streetName = this.slideOneForm.controls.addPreviousAddressItem['controls'][index].get('previous_street_name');
    let streetType = this.slideOneForm.controls.addPreviousAddressItem['controls'][index].get('previous_street_type');
    if($event == 'nonStandard'){
      //this.address_format = $event;
      streetNumber.setValidators(Validators.required);
      streetName.setValidators(Validators.required);
      streetType.setValidators(Validators.required);
    }else if($event == 'poBox'){
      //this.address_format = $event;
      streetNumber.setValidators(null);
      streetName.setValidators(null);
      streetType.setValidators(null);
    }else{
      //this.address_format = $event;
      streetNumber.setValidators(Validators.required);
      streetName.setValidators(Validators.required);
      streetType.setValidators(Validators.required);
    }
    streetNumber.updateValueAndValidity();
    streetName.updateValueAndValidity();
    streetType.updateValueAndValidity();
    this.signupSlider.resize();
    this.signupSlider.update();    
  }

  public changeDoYouHaveChild($event, type, index){
    if(index == 'main'){
      this.do_you_have_children_yes_or_no = $event;
    }else{
      this.setSecondaryChilderValue(index);
    }
    
    this.signupSlider.resize();
    this.signupSlider.update();
    if($event == undefined){
      return false;
    }
    this.new_val = $event;
    this.old_val = '';
    var property = '';
    if(index == 'main'){
      if(type == 'do_you_have_children'){
        this.old_val = (this.applicant_details.do_you_have_children == undefined) ? '' : this.applicant_details.do_you_have_children;
        property = 'Do You Have Children';
      }
    }
    if(this.new_val != this.old_val){
      //this.change_log_string += type+'='+this.old_val+':'+this.new_val+';';
      this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': index, 'index2': index});
    }
  }

  public changeHowManyChildren($event, type, index){
    if(index == 'main'){
      this.how_many_children_number = $event._value;
    }else{
      this.secondaryChildrenCount(index)
    }
    this.signupSlider.resize();
    this.signupSlider.update();
    this.new_val = $event._value;
    this.old_val = '';
    var property = '';
    if(index == 'main'){
      if(type == 'how_many_children'){
        this.old_val = (this.applicant_details.how_many_children == undefined) ? '' : this.applicant_details.how_many_children;
        property = 'How Many Children';
      }
    }
    if(this.new_val != this.old_val){
      //this.change_log_string += type+'='+this.old_val+':'+this.new_val+';';
      this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': index, 'index2': index});
    }
  }

  public changeEmploymentType($event, type){
    let gcurrentlyEmployment = this.slideThreeForm.get('currentlyEmployment');
    let gexpectFindWork = this.slideThreeForm.get('expectFindWork');
    let gstatusyourEmployment = this.slideThreeForm.get('statusyourEmployment');
    let gyour_occupation = this.slideThreeForm.get('your_occupation');
    let gstart_date = this.slideThreeForm.get('start_date');
    let gbusiness_name = this.slideThreeForm.get('business_name');
    let gnature_of_business = this.slideThreeForm.get('nature_of_business');
    if($event == 'payg'){
      this.employementType = $event;
      gbusiness_name.setValidators(null);
      gnature_of_business.setValidators(null);
      gcurrentlyEmployment.setValidators(Validators.required);

      if(this.employment_details.employementType == 'self-employed'){
        this.new_val = '';
        this.old_val = this.employment_details.business_name;
        property = 'Business Name';
        if(this.new_val != this.old_val){
          this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
        }
        this.old_val = this.employment_details.type_of_entity;
        property = 'Type of Entity';
        if(this.new_val != this.old_val){
          this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
        }
        this.old_val = this.employment_details.abn_acn;
        property = 'ABN/ACN';
        if(this.new_val != this.old_val){
          this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
        }
        this.old_val = this.employment_details.nature_of_business;
        property = 'Nature of Business';
        if(this.new_val != this.old_val){
          this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
        }
      }
    }else{
      this.employementType = $event;
      gcurrentlyEmployment.setValidators(null);
      gexpectFindWork.setValidators(null);
      gstatusyourEmployment.setValidators(null);
      gyour_occupation.setValidators(null);
      gstart_date.setValidators(null);
      gbusiness_name.setValidators(Validators.required);
      gnature_of_business.setValidators(Validators.required);

      if(this.employment_details.employementType == 'payg'){
        this.new_val = '';
        this.old_val = this.employment_details.currentlyEmployment;
        property = 'Currently Employment';
        if(this.new_val != this.old_val){
          this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
        }
        this.old_val = (this.employment_details.statusyouredEmployment == undefined) ? '' : this.employment_details.statusyouredEmployment;
        property = 'What is the status of your employment?';
        if(this.new_val != this.old_val){
          this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
        }
        this.old_val = this.employment_details.your_occupation;
        property = 'Your Occupation';
        if(this.new_val != this.old_val){
          this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
        }
        this.old_val = this.employment_details.start_date;
        property = 'Employment role date';
        if(this.new_val != this.old_val){
          this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
        }
        this.old_val = this.employment_details.expectFindWork;
        property = 'In how long do you expect to find work?';
        if(this.new_val != this.old_val){
          this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
        }
      }
    }
    gcurrentlyEmployment.updateValueAndValidity();
    gexpectFindWork.updateValueAndValidity();
    gstatusyourEmployment.updateValueAndValidity();
    gyour_occupation.updateValueAndValidity();
    gstart_date.updateValueAndValidity();
    gbusiness_name.updateValueAndValidity();
    gnature_of_business.updateValueAndValidity();
    this.signupSlider.resize();
    this.signupSlider.update();

    this.new_val = $event;
    this.old_val = '';
    var property = '';
    if(type == 'employementType'){
      this.old_val = (this.employment_details.employementType == undefined) ? '' : this.employment_details.employementType;
      property = 'Employement Type';
    }
    if(this.new_val != this.old_val){
      this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
    }
  }

  public currentEmployeed(value, type){
    let gexpectFindWork = this.slideThreeForm.get('expectFindWork');
    let gstatusyourEmployment = this.slideThreeForm.get('statusyourEmployment');
    let gyour_occupation = this.slideThreeForm.get('your_occupation');
    let gstart_date = this.slideThreeForm.get('start_date');
    let gbusiness_name = this.slideThreeForm.get('business_name');
    let gnature_of_business = this.slideThreeForm.get('nature_of_business');
    if(value == 'yes'){
      this.isCurrentEmployeed = value;
      gstatusyourEmployment.setValidators(Validators.required);
      gyour_occupation.setValidators(Validators.required);
      gstart_date.setValidators(Validators.required);
      gexpectFindWork.setValidators(null);
    }else{
      this.isCurrentEmployeed = value;
      gexpectFindWork.setValidators(Validators.required);
      gstatusyourEmployment.setValidators(null);
      gyour_occupation.setValidators(null);
      gstart_date.setValidators(null);
    }
    gbusiness_name.setValidators(null);
    gnature_of_business.setValidators(null);

    gexpectFindWork.updateValueAndValidity();
    gstatusyourEmployment.updateValueAndValidity();
    gyour_occupation.updateValueAndValidity();
    gstart_date.updateValueAndValidity();
    gbusiness_name.updateValueAndValidity();
    gnature_of_business.updateValueAndValidity();
    this.signupSlider.resize();
    this.signupSlider.update();
    //change log data
    this.new_val = value;
    this.old_val = '';
    var property = '';
    if(type == 'currentlyEmployment'){
      this.old_val = (this.employment_details.currentlyEmployment == undefined) ? '' : this.employment_details.currentlyEmployment;
      property = 'Currently Employment';
    }
    if(this.new_val != this.old_val){
      //this.change_log_string += type+'='+this.old_val+':'+this.new_val+';';
      this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val});
    }
  }

  public expectedFindWork(value){
    if(value == 'other'){
      this.expectedWork = 'other';
    }else{
      this.expectedWork = '';
    }
    this.signupSlider.resize();
    this.signupSlider.update();
  }

  public statusyouredEmployment(value, type, index){
    if(value == 'other'){
      this.statusEmployment = 'other';
    }else{
      this.statusEmployment = '';
    }
    this.signupSlider.resize();
    this.signupSlider.update();
    this.new_val = value;
    this.old_val = '';
    var property = '';
    if(index == 'main'){
      if(type == 'statusyourEmployment'){
        this.old_val = (this.applicant_details.statusyourEmployment == undefined) ? '' : this.applicant_details.statusyourEmployment;
        property = 'Status Your Employment';
      }
    }
    if(this.new_val != this.old_val){
      //this.change_log_string += type+'='+this.old_val+':'+this.new_val+';';
      this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': index, 'index2': index});
    }
  }

  changeEmploymentTypePrev($event, index){
    let gcurrentlyEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('currentlyEmployment');
    let gexpectFindWork = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('expectFindWork');
    let gstatusyourEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('statusyourEmployment');
    let gyour_occupation = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('your_occupation');
    let gstart_date = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('start_date');
    let gbusiness_name = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('business_name');
    let gnature_of_business = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('nature_of_business');
    if($event == 'payg'){
      //this.employementType = $event;
      gbusiness_name.setValidators(null);
      gnature_of_business.setValidators(null);
      gcurrentlyEmployment.setValidators(Validators.required);
    }else if($event == 'unemployed'){
      gcurrentlyEmployment.setValidators(null);
      gexpectFindWork.setValidators(null);
      gstatusyourEmployment.setValidators(null);
      gyour_occupation.setValidators(null);
      gstart_date.setValidators(null);
      gbusiness_name.setValidators(null);
      gnature_of_business.setValidators(null);
      
    }else{
      //this.employementType = $event;
      gcurrentlyEmployment.setValidators(null);
      gexpectFindWork.setValidators(null);
      gstatusyourEmployment.setValidators(null);
      gyour_occupation.setValidators(null);
      gstart_date.setValidators(null);
      gbusiness_name.setValidators(Validators.required);
      gnature_of_business.setValidators(Validators.required);
    }
    gcurrentlyEmployment.updateValueAndValidity();
    gexpectFindWork.updateValueAndValidity();
    gstatusyourEmployment.updateValueAndValidity();
    gyour_occupation.updateValueAndValidity();
    gstart_date.updateValueAndValidity();
    gbusiness_name.updateValueAndValidity();
    gnature_of_business.updateValueAndValidity();
    this.signupSlider.resize();
    this.signupSlider.update();
    
  }

  currentEmployeedPrev(value, index){
    let gexpectFindWork = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('expectFindWork');
    let gstatusyourEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('statusyourEmployment');
    let gyour_occupation = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('your_occupation');
    let gstart_date = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('start_date');
    let gbusiness_name = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('business_name');
    let gnature_of_business = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('nature_of_business');
    if(value == 'yes'){
      //this.isCurrentEmployeed = value;
      gstatusyourEmployment.setValidators(Validators.required);
      gyour_occupation.setValidators(Validators.required);
      gstart_date.setValidators(Validators.required);
      gexpectFindWork.setValidators(null);
    }else{
      //this.isCurrentEmployeed = value;
      gexpectFindWork.setValidators(Validators.required);
      gstatusyourEmployment.setValidators(null);
      gyour_occupation.setValidators(null);
      gstart_date.setValidators(null);
    }
    gbusiness_name.setValidators(null);
    gnature_of_business.setValidators(null);

    gexpectFindWork.updateValueAndValidity();
    gstatusyourEmployment.updateValueAndValidity();
    gyour_occupation.updateValueAndValidity();
    gstart_date.updateValueAndValidity();
    gbusiness_name.updateValueAndValidity();
    gnature_of_business.updateValueAndValidity();
    this.signupSlider.resize();
    this.signupSlider.update();
  }

  changeEmploymentTypeaddi($event, index){
    let gcurrentlyEmployment = this.slideThreeForm.controls.addEmploymentItem['controls'][index].get('currentlyEmployment');
    let gexpectFindWork = this.slideThreeForm.controls.addEmploymentItem['controls'][index].get('expectFindWork');
    let gstatusyourEmployment = this.slideThreeForm.controls.addEmploymentItem['controls'][index].get('statusyourEmployment');
    let gyour_occupation = this.slideThreeForm.controls.addEmploymentItem['controls'][index].get('your_occupation');
    let gstart_date = this.slideThreeForm.controls.addEmploymentItem['controls'][index].get('start_date');
    let gbusiness_name = this.slideThreeForm.controls.addEmploymentItem['controls'][index].get('business_name');
    let gnature_of_business = this.slideThreeForm.controls.addEmploymentItem['controls'][index].get('nature_of_business');
    if($event == 'payg'){
      //this.employementType = $event;
      gbusiness_name.setValidators(null);
      gnature_of_business.setValidators(null);
      gcurrentlyEmployment.setValidators(Validators.required);
    }else{
      //this.employementType = $event;
      gcurrentlyEmployment.setValidators(null);
      gexpectFindWork.setValidators(null);
      gstatusyourEmployment.setValidators(null);
      gyour_occupation.setValidators(null);
      gstart_date.setValidators(null);
      gbusiness_name.setValidators(Validators.required);
      gnature_of_business.setValidators(Validators.required);
    }
    gcurrentlyEmployment.updateValueAndValidity();
    gexpectFindWork.updateValueAndValidity();
    gstatusyourEmployment.updateValueAndValidity();
    gyour_occupation.updateValueAndValidity();
    gstart_date.updateValueAndValidity();
    gbusiness_name.updateValueAndValidity();
    gnature_of_business.updateValueAndValidity();
    this.signupSlider.resize();
    this.signupSlider.update();
  }

  currentEmployeedaddi(value, index){
    let gexpectFindWork = this.slideThreeForm.controls.addEmploymentItem['controls'][index].get('expectFindWork');
    let gstatusyourEmployment = this.slideThreeForm.controls.addEmploymentItem['controls'][index].get('statusyourEmployment');
    let gyour_occupation = this.slideThreeForm.controls.addEmploymentItem['controls'][index].get('your_occupation');
    let gstart_date = this.slideThreeForm.controls.addEmploymentItem['controls'][index].get('start_date');
    let gbusiness_name = this.slideThreeForm.controls.addEmploymentItem['controls'][index].get('business_name');
    let gnature_of_business = this.slideThreeForm.controls.addEmploymentItem['controls'][index].get('nature_of_business');
    if(value == 'yes'){
     // this.isCurrentEmployeed = value;
      gstatusyourEmployment.setValidators(Validators.required);
      gyour_occupation.setValidators(Validators.required);
      gstart_date.setValidators(Validators.required);
      gexpectFindWork.setValidators(null);
    }else{
      //this.isCurrentEmployeed = value;
      gexpectFindWork.setValidators(Validators.required);
      gstatusyourEmployment.setValidators(null);
      gyour_occupation.setValidators(null);
      gstart_date.setValidators(null);
    }
    gbusiness_name.setValidators(null);
    gnature_of_business.setValidators(null);

    gexpectFindWork.updateValueAndValidity();
    gstatusyourEmployment.updateValueAndValidity();
    gyour_occupation.updateValueAndValidity();
    gstart_date.updateValueAndValidity();
    gbusiness_name.updateValueAndValidity();
    gnature_of_business.updateValueAndValidity();
    this.signupSlider.resize();
    this.signupSlider.update();
  }

  changeEmploymentTypeAddiPrev($event, index, index1){
    let gcurrentlyEmployment = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('currentlyEmployment');
    let gexpectFindWork = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('expectFindWork');
    let gstatusyourEmployment = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('statusyourEmployment');
    let gyour_occupation = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('your_occupation');
    let gstart_date = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('start_date');
    let gbusiness_name = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('business_name');
    let gnature_of_business = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('nature_of_business');
    if($event == 'payg'){
      //this.employementType = $event;
      gbusiness_name.setValidators(null);
      gnature_of_business.setValidators(null);
      gcurrentlyEmployment.setValidators(Validators.required);
    }else if($event == 'unemployed'){
      gcurrentlyEmployment.setValidators(null);
      gexpectFindWork.setValidators(null);
      gstatusyourEmployment.setValidators(null);
      gyour_occupation.setValidators(null);
      gstart_date.setValidators(null);
      gbusiness_name.setValidators(null);
      gnature_of_business.setValidators(null);
    }else{
      //this.employementType = $event;
      gcurrentlyEmployment.setValidators(null);
      gexpectFindWork.setValidators(null);
      gstatusyourEmployment.setValidators(null);
      gyour_occupation.setValidators(null);
      gstart_date.setValidators(null);
      gbusiness_name.setValidators(Validators.required);
      gnature_of_business.setValidators(Validators.required);
    }
    gcurrentlyEmployment.updateValueAndValidity();
    gexpectFindWork.updateValueAndValidity();
    gstatusyourEmployment.updateValueAndValidity();
    gyour_occupation.updateValueAndValidity();
    gstart_date.updateValueAndValidity();
    gbusiness_name.updateValueAndValidity();
    gnature_of_business.updateValueAndValidity();
    this.signupSlider.resize();
    this.signupSlider.update();
  }

  currentEmployeedAddiPrev(value, index, index1){
    let gexpectFindWork = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('expectFindWork');
    let gstatusyourEmployment = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('statusyourEmployment');
    let gyour_occupation = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('your_occupation');
    let gstart_date = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('start_date');
    let gbusiness_name = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('business_name');
    let gnature_of_business = this.formApplicantEmployment.controls[index]['controls']['previousEmploymentItem'].controls[index1].get('nature_of_business');
    if(value == 'yes'){
      //this.isCurrentEmployeed = value;
      gstatusyourEmployment.setValidators(Validators.required);
      gyour_occupation.setValidators(Validators.required);
      gstart_date.setValidators(Validators.required);
      gexpectFindWork.setValidators(null);
    }else{
      //this.isCurrentEmployeed = value;
      gexpectFindWork.setValidators(Validators.required);
      gstatusyourEmployment.setValidators(null);
      gyour_occupation.setValidators(null);
      gstart_date.setValidators(null);
    }
    gbusiness_name.setValidators(null);
    gnature_of_business.setValidators(null);

    gexpectFindWork.updateValueAndValidity();
    gstatusyourEmployment.updateValueAndValidity();
    gyour_occupation.updateValueAndValidity();
    gstart_date.updateValueAndValidity();
    gbusiness_name.updateValueAndValidity();
    gnature_of_business.updateValueAndValidity();
    this.signupSlider.resize();
    this.signupSlider.update();
  }

  

  myModelVariable = '';

  public convert(event: any) {
    this.myModelVariable = event.target.value.replace(/[^\d\.]/g ,'');
  }

  slideChanged() {
    //let currentIndex = this.signupSlider.getActiveIndex();
  }

  public selectChange(e) {
    //console.log(e);
  }

  ngAfterViewInit(){
    this.getPlaceAutocomplete();
    this.signupSlider.lockSwipes(true);
    let thisssss =this;
    // this.signupSlider.autoHeight=true;
    $(document).ready(function(){
      $('.customPagination li').on('click',function(){
        var pos=$(this).offset().left;
        var currentscroll=$(".customPagination").scrollLeft();
        var divwidth=$(".customPagination").width();
        pos=(pos+currentscroll)-(divwidth/2);
        $('.customPagination').animate({
           scrollLeft: pos+divwidth/6
        });
      });
      $(document).on('keypress', '.autoEmail', function(e){
        $(this).closest('.hintEmail').show();
        $(this).parents('.formGroupBG').find('.hintEmail').show();
        const searchTerm = $(this).val();
        if (!searchTerm) {
          thisssss.isItemAvailable = false;
          return;
        }

        thisssss.emailList = thisssss.allUserData.filter(currentUser => {
          thisssss.isItemAvailable = true;
          //let fullName = currentUser.firstname+' '+currentUser.lastname;
          if (currentUser.email && searchTerm) {
            if (currentUser.email.indexOf(searchTerm) > -1) {
              return true;
            }
            return false;
          }
        })
        if(thisssss.emailList.length == 0){
          thisssss.isItemAvailable = false;
        }
      })
      $(document).click(function(e){
        if ($(e.target).closest(".hintEmail").length === 0) {
          // rest code here
          $('.hintEmail').hide();
        }else{
        }
      })
    });
  }

  public next1(){
    if(!this.slideOneForm.valid){
      this.signupSlider.slideTo(0);

      this.slideOneForm.get('firstname').markAsDirty();
      this.slideOneForm.get('firstname').markAsTouched();

      this.slideOneForm.get('lastname').markAsDirty();
      this.slideOneForm.get('lastname').markAsTouched();

      this.slideOneForm.get('email').markAsDirty();
      this.slideOneForm.get('email').markAsTouched();

      this.slideOneForm.get('mobile_phone').markAsDirty();
      this.slideOneForm.get('mobile_phone').markAsTouched();

      this.slideOneForm.get('date_of_birth').markAsDirty();
      this.slideOneForm.get('date_of_birth').markAsTouched();

      this.slideOneForm.get('primayr_goal_intention').markAsDirty();
      this.slideOneForm.get('primayr_goal_intention').markAsTouched();

      this.slideOneForm.get('address_type').markAsDirty();
      this.slideOneForm.get('address_type').markAsTouched();

      this.slideOneForm.get('address_format').markAsDirty();
      this.slideOneForm.get('address_format').markAsTouched();

      this.slideOneForm.get('street_number').markAsDirty();
      this.slideOneForm.get('street_number').markAsTouched();

      this.slideOneForm.get('street_name').markAsDirty();
      this.slideOneForm.get('street_name').markAsTouched();

      this.slideOneForm.get('street_type').markAsDirty();
      this.slideOneForm.get('street_type').markAsTouched();

      this.slideOneForm.get('city').markAsDirty();
      this.slideOneForm.get('city').markAsTouched();

      this.slideOneForm.get('state').markAsDirty();
      this.slideOneForm.get('state').markAsTouched();

      this.slideOneForm.get('postcode').markAsDirty();
      this.slideOneForm.get('postcode').markAsTouched();

      this.slideOneForm.get('country').markAsDirty();
      this.slideOneForm.get('country').markAsTouched();

      this.slideOneForm.get('housing_situation').markAsDirty();
      this.slideOneForm.get('housing_situation').markAsTouched();

      this.slideOneForm.get('move_in_date').markAsDirty();
      this.slideOneForm.get('move_in_date').markAsTouched();

      this.slideOneForm.get('reference_broker').markAsDirty();
      this.slideOneForm.get('reference_broker').markAsTouched();

      if(!this.slideOneForm.valid){
        this.slideOneForm.controls['addAnotherApplicantItem']['controls'].forEach(formGroup => {
          this.markFormGroupTouched(formGroup);
        });
        this.slideOneForm.controls['addPreviousAddressItem']['controls'].forEach(formGroup => {
          this.markFormGroupTouched(formGroup);
        });
        this.slideOneForm.controls['addAddressRelationshipItem']['controls'].forEach(formGroup => {
          this.markFormGroupTouched(formGroup);
        });
      }

      let formSelectorClass: HTMLElement = this.el.nativeElement.querySelector(
        ".firstSlideForm [formcontrolname].ng-invalid"
      );

      this.scrollToFirstInvalidControl(formSelectorClass);

    }else{
      this.auto_save_and_submit('step1');
    }
    this.signupSlider.resize();
    this.signupSlider.update();
  }

  public scrollToFirstInvalidControl(formSlide){
    let firstInvalidControl = formSlide;
    const slideTab: HTMLElement = this.el.nativeElement.querySelector(
      ".bar-buttons.invalid button"
    );
    if(slideTab != null){
      slideTab.click();
    }
    let scrollContent: HTMLElement = this.el.nativeElement.querySelector(".scroll-content")
    scrollContent.scroll({
      top: this.getTopOffset(firstInvalidControl, scrollContent),
      left: 0,
      behavior: "smooth"
    });
    fromEvent(scrollContent, "scroll")
      .pipe(
        debounceTime(150),
        take(1)
      )
      .subscribe(() => firstInvalidControl.focus());
  }

  private getTopOffset(controlEl: HTMLElement, scrollContent: HTMLElement): number {
    const labelOffset = 100;
    return controlEl.getBoundingClientRect().top + scrollContent.scrollTop - labelOffset;
  }

  public next2(){
    if(!this.slideTwoForm.valid){
      this.signupSlider.slideTo(1);

      this.slideTwoForm.get('gender').markAsDirty();
      this.slideTwoForm.get('gender').markAsTouched();

      this.slideTwoForm.get('current_marital_status').markAsDirty();
      this.slideTwoForm.get('current_marital_status').markAsTouched();

      this.slideTwoForm.get('do_you_have_children').markAsDirty();
      this.slideTwoForm.get('do_you_have_children').markAsTouched();

      this.slideTwoForm.get('how_many_children').markAsDirty();
      this.slideTwoForm.get('how_many_children').markAsTouched();

      this.slideTwoForm.get('first_child_age').markAsDirty();
      this.slideTwoForm.get('first_child_age').markAsTouched();

      this.slideTwoForm.get('second_child_age').markAsDirty();
      this.slideTwoForm.get('second_child_age').markAsTouched();

      this.slideTwoForm.get('third_child_age').markAsDirty();
      this.slideTwoForm.get('third_child_age').markAsTouched();

      this.slideTwoForm.get('fourth_child_age').markAsDirty();
      this.slideTwoForm.get('fourth_child_age').markAsTouched();

      this.slideTwoForm.get('fifth_child_age').markAsDirty();
      this.slideTwoForm.get('fifth_child_age').markAsTouched();

      this.slideTwoForm.get('sixth_child_age').markAsDirty();
      this.slideTwoForm.get('sixth_child_age').markAsTouched();

      let formSelectorClass2: HTMLElement = this.el.nativeElement.querySelector(
        ".secondSlideForm [formcontrolname].ng-invalid"
      );
      this.scrollToFirstInvalidControl(formSelectorClass2);

    }else{
      this.signupSlider.lockSwipes(false);
      this.signupSlider.slideNext();
      this.signupSlider.lockSwipes(true);
      this.edit_contact_uid = window.localStorage.getItem("contact_uid");
      if(this.edit_contact_uid == '' || this.edit_contact_uid == null || this.edit_contact_uid == undefined){
        this.edit_contact_uid = window.localStorage.getItem("edit_contact_uid");
      }
      this.auto_save_and_submit('step2');
    }    
    this.signupSlider.resize();
    this.signupSlider.update();
  }

  public next3(){
    if(!this.slideThreeForm.valid){
      this.signupSlider.slideTo(2);

      this.slideThreeForm.get('employementType').markAsDirty();
      this.slideThreeForm.get('employementType').markAsTouched();

      this.slideThreeForm.get('currentlyEmployment').markAsDirty();
      this.slideThreeForm.get('currentlyEmployment').markAsTouched();

      this.slideThreeForm.get('statusyourEmployment').markAsDirty();
      this.slideThreeForm.get('statusyourEmployment').markAsTouched();

      this.slideThreeForm.get('your_occupation').markAsDirty();
      this.slideThreeForm.get('your_occupation').markAsTouched();

      this.slideThreeForm.get('start_date').markAsDirty();
      this.slideThreeForm.get('start_date').markAsTouched();

      this.slideThreeForm.get('expectFindWork').markAsDirty();
      this.slideThreeForm.get('expectFindWork').markAsTouched();

      this.slideThreeForm.get('business_name').markAsDirty();
      this.slideThreeForm.get('business_name').markAsTouched();

      this.slideThreeForm.get('nature_of_business').markAsDirty();
      this.slideThreeForm.get('nature_of_business').markAsTouched();

      let formSelectorClass3: HTMLElement = this.el.nativeElement.querySelector(
        ".thirdSlideForm [formcontrolname].ng-invalid"
      );
      
      this.scrollToFirstInvalidControl(formSelectorClass3);

    }else if(!this.incomeForm.valid){
      this.incomeForm.controls['itemRows']['controls'].forEach(formGroup => {
        this.markFormGroupTouched(formGroup);
      });
      let formSelectorClass3: HTMLElement = this.el.nativeElement.querySelector(
        ".thirdSlideForm [formcontrolname].ng-invalid"
      );
      

      this.scrollToFirstInvalidControl(formSelectorClass3);
    }else{
      this.signupSlider.lockSwipes(false);
      this.signupSlider.slideNext();
      this.signupSlider.lockSwipes(true);
      this.auto_save_and_submit('step3');
    }
    this.signupSlider.resize();
    this.signupSlider.update();
  }

  public next4(){
    if(!this.assetsForm.valid){
      this.assetsForm.controls['itemRowsAssets']['controls'].forEach(formGroup => {
        this.markFormGroupTouched(formGroup);
      });
      let formSelectorClass4: HTMLElement = this.el.nativeElement.querySelector(
        ".fourthSlideForm [formcontrolname].ng-invalid"
      );
      
      this.scrollToFirstInvalidControl(formSelectorClass4);
    }else if(!this.liabilitiesForm.valid){
      this.liabilitiesForm.controls['itemRowsLiabilities']['controls'].forEach(formGroup => {
        this.markFormGroupTouched(formGroup);
      });
      let formSelectorClass4: HTMLElement = this.el.nativeElement.querySelector(
        ".fourthSlideForm [formcontrolname].ng-invalid"
      );
      
      this.scrollToFirstInvalidControl(formSelectorClass4);
    }else{
      this.signupSlider.lockSwipes(false);
      this.signupSlider.slideNext();
      this.signupSlider.lockSwipes(true);
      this.auto_save_and_submit('step4');
    }
    this.signupSlider.resize();
    this.signupSlider.update();
  }

  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      control.updateValueAndValidity();
      control.markAsDirty();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  public prev(){
    this.signupSlider.lockSwipes(false);
    this.signupSlider.slidePrev();
    this.signupSlider.lockSwipes(true);
    if(this.edit_contact_uid == "" || this.edit_contact_uid == null || this.edit_contact_uid == undefined){

    }else{
      // this.editgetIncome(this.edit_contact_uid).subscribe((data)=>{
      //   if(this.formArr.length > 0){
      //     for(let a = 0; a < this.formArr.length; a++){
      //       this.formArr.removeAt(a);
      //     }
      //   }
      //   if(data.length > 0 && this.formArr.length == 0){
      //     this.allIncomess = data;
      //     for(let i = 0; i < this.allIncomess.length; i++){
      //       this.formArr.push(this.initItemRowsIncomesLoad(this.allIncomess[i]));
      //     }
      //     this.formArr.updateValueAndValidity();
      //     this.incomeForm.updateValueAndValidity();
      //   }else{
      //     this.allIncomess = [];
      //   }
      //   this.signupSlider.resize();
      //   this.signupSlider.update();
      // });
      /*get assets*/
      // this.editgetAllassets(this.edit_contact_uid).subscribe((data)=>{
      //   if(this.formArrAssets.length > 0){
      //     for(let b = 0; b < this.formArrAssets.length; b++){
      //       this.formArrAssets.removeAt(b);
      //     }
      //   }
      //   if(data.length > 0 && this.formArrAssets.length == 0){
      //     this.total_a_length = data.length;
      //     this.allAssetss = data;
      //     for(let i = 0; i < this.allAssetss.length; i++){
      //       this.formArrAssets.push(this.initItemRowsAssetsLoad(this.allAssetss[i]));
      //     }

      //   }else{
      //     window.localStorage.setItem("total_assets", '0');
      //     this.allAssetss = [];
      //   }
      //   this.signupSlider.resize();
      //   this.signupSlider.update();
      // });
      /*get liabilities*/
      
    }
  }

  save(){
    this.submitAttempt = true;
    if(!this.realEstateForm.valid){
      this.realEstateForm.controls['itemRowsRealEstates']['controls'].forEach(formGroup => {
        this.markFormGroupTouched(formGroup);
      });
      let formSelectorClass4_1: HTMLElement = this.el.nativeElement.querySelector(
        ".fifthSlideForm [formcontrolname].ng-invalid"
      );
      
      this.scrollToFirstInvalidControl(formSelectorClass4_1);
    }else{
      this.submitAttempt = false;
      this.loadingProvider.startLoading();
      this.auto_save_and_submit('finish');      
    }
    this.signupSlider.resize();
    this.signupSlider.update();
  }

  

  auto_save_and_submit(ttype = 'finish'){
    let uid = window.localStorage.getItem("uid");

    let formSelectorClass: HTMLElement = this.el.nativeElement.querySelector(
      ".slides.slides-md"
    );
    
    if(uid != null){
      let allData = {};
      let incomeForm = {};
      let assetsForm = {};
      let liabilitiesForm = {};
      let realEstateForm = {};
      if(ttype != 'finish'){
        if(ttype == 'step1'){

          allData = this.slideOneForm.value; 
          if(allData['middlename'] == undefined){
            allData['middlename'] = '';
          }
          if(allData['building_name'] == undefined){
            allData['building_name'] = '';
          }
          if(allData['unit_number'] == undefined){
            allData['unit_number'] = '';
          }
          if(allData['floor_number'] == undefined){
            allData['floor_number'] = '';
          }
          if(allData['poboxlabel'] == undefined){
            allData['poboxlabel'] = '';
          }
          if(allData['reference_broker'] == undefined || allData['reference_broker'] == null || allData['reference_broker'] == ''){
            allData['reference_broker'] = uid;
          }

          allData['password'] = this.stringGen(12);
          allData['contact_type'] = 'Primary Contact';
          allData["phoneNumber"] = "+6"+allData['mobile_phone'].split(" ").join("");

        }else if(ttype == 'step2'){
          allData = this.slideTwoForm.value;          
        }else if(ttype == 'step3'){
          allData = this.slideThreeForm.value;          
          incomeForm = this.incomeForm.value;
        }else if(ttype == 'step4'){
          allData = this.slideFourForm.value;
          assetsForm = this.assetsForm.value;
          liabilitiesForm = this.liabilitiesForm.value;          
        }
      }else{
        realEstateForm = this.realEstateForm.value;
        allData = []//this.slideOneForm;          
      }

      if(this.document_id == undefined){
        this.document_id = this.SDF_form_document_id;
      }
      if(this.primary_uid == undefined){
        this.primary_uid = this.edit_contact_uid;
      }
      let postData = {
        "contact_uid": this.edit_contact_uid,
        "SDF_form_document_id": this.SDF_form_document_id,
        "user_document_id": this.document_id,
        "reference_broker": allData['reference_broker'],
        "userData": allData,
        "incomeForm": incomeForm,
        "assetsData": assetsForm,
        "liabilitiesData": liabilitiesForm,
        "realEstateForm": realEstateForm,
        "primary_uid": this.primary_uid,
        "secondary_uid": this.secondary_uid,
        "document_id": this.document_id,
        "newASFCreating": this.newASFCreating,
        "applicant_details": this.change_log_string,
        "employment_details": this.employment_details,
        "income_details": this.income_details,
        "asset_details": this.asset_details,
        "liability_details": this.liability_details,
        "realEstate_details": this.realEstate_details,
        "uid": uid
      }
      this.change_log_string = [];
      this.income_details = [];
      this.asset_details = [];
      this.liability_details = [];
      this.realEstate_details = [];
      if(ttype == 'step1'){
        if(this.SDF_form_document_id == "" || this.SDF_form_document_id == null || this.SDF_form_document_id == undefined){
          this.newASFCreating = 1;
        }
        postData['newASFCreating'] = this.newASFCreating;
        postData['primary_uid'] = [];
        postData['secondary_uid'] = [];
        postData['document_id'] = allData['user_document_id'];
        var headers = new Headers();
        headers.append("Accept", 'application/json');
        headers.append('Content-Type', 'application/json' );
        const requestOptions = new RequestOptions({ headers: headers });
        
        if(this.checkContact == 1 || this.checkAddiContactStatus == 1){
          return false;
        }else{
          this.loadingProvider.startLoading();
          var url = this.EnvDataService.EnvData.sendbox_api+"/createSDFUser";
          this.http.post(url, postData, requestOptions)
          .subscribe(data => {
            if(data['_body'] == 'The email address is already in use by another account.'){
              this.presentToast('The primary email address is already in use by another account.');
            }else if(data['_body'] == 'The user with the provided phone number already exists.'){
              this.presentToast('The user with the provided primary phone number already exists.');
            }else if(data['_body'] == 'TOO_LONG'){
              this.presentToast('Invalid Primary Phone Number.');
            }else if(data['_body'] == 'TOO_SHORT'){
              this.presentToast('Invalid Primary Phone Number.');
            }else if(data['_body'] == 'Invalid format.'){
              this.presentToast('Invalid Primary Phone Number.');
            }else if(data['_body'] == 'The phone number must be a non-empty E.164 standard compliant identifier string.'){
              this.presentToast('Invalid Primary Phone Number.');
            }else if(data['_body'] == 'The email address is improperly formatted.'){
              this.presentToast('Invalid Primary Email Address.');
            }else{
              //console.log('data_body', data['_body']);
              let responseData = JSON.parse(data['_body']);
              responseData['step'] = 1
              responseData['document_id'] = responseData.primary_uid[0].document_id
              this.SDF_form_document_id = responseData.document_id;
              this.primary_uid = responseData.primary_uid[0].primary_uid;
              //this.secondary_uid = responseData.secondary_uid;
              this.document_id = responseData.primary_uid[0].document_id;

              if(this.SDF_form_document_id != undefined){
                this.SdfFormService.get_second_user_data(this.SDF_form_document_id)
                .then((get_second_user_data) => {
                  this.secondary_uid = [];
                  let thiss = this;
                  Object.keys(get_second_user_data).forEach(function(key) {
                    thiss.secondary_uid.push({'secondary_uid': get_second_user_data[key].uid, 'document_id': get_second_user_data[key].document_id})
                  })
                })
              }
              this.scrollToFirstInvalidControl(formSelectorClass);

              this.SdfFormService.UpdateSDFForm(responseData, postData);
              this.signupSlider.lockSwipes(false);
              this.signupSlider.slideNext();
              this.signupSlider.lockSwipes(true);
            }
            this.loadingProvider.stopLoading();
          }, error => {
            this.loadingProvider.stopLoading();
            this.presentToast(error.message);
          });
        }

      }else if(ttype == 'step2'){
        postData['step'] = 2;
        this.SdfFormService.UpdateSDFForm(postData, postData);
        this.scrollToFirstInvalidControl(formSelectorClass);
      }else if(ttype == 'step3'){
        postData['step'] = 3;
        this.SdfFormService.UpdateSDFForm(postData, postData);
        this.scrollToFirstInvalidControl(formSelectorClass);
      }else if(ttype == 'step4'){
        postData['step'] = 4;
        this.SdfFormService.UpdateSDFForm(postData, postData);
        this.scrollToFirstInvalidControl(formSelectorClass);
      }else{
        postData['step'] = 5;
        this.SdfFormService.UpdateSDFForm(postData, postData);
        this.loadingProvider.stopLoading();
        this.navCtrl.push(ViewContactPage,{
          contact_uid: this.primary_uid, 
          SDF_form_document_id: this.SDF_form_document_id
        });
      }
    }
  }

  //applicant section
  get formApplicant() {
    return this.slideOneForm.get('addAnotherApplicantItem') as FormArray;
  }
  //applicant address section
  get formArrApplicantAddress() {
    return this.slideOneForm.get('addAddressRelationshipItem') as FormArray;
  }
  //applicant previous address section
  get formPreviousAddress() {
    return this.slideOneForm.get('addPreviousAddressItem') as FormArray;
  }
  //family section
  get formApplicantFamily() {
    return this.slideTwoForm.get('addFamilyItem') as FormArray;
  }
  //employment section
  get formPrimaryEmployment() {
    return this.slideThreeForm.get('addPrimaryEmploymentItem') as FormArray;
  }
  //employment section
  get formApplicantEmployment() {
    return this.slideThreeForm.get('addEmploymentItem') as FormArray;
  }
  //income section
  get formArr() {
    return this.incomeForm.get('itemRows') as FormArray;
  }
  get formApplicantIncome() {
    return this.incomeForm.get("addApplicantIncomeItem") as FormArray;
  }
  //assets section
  get formArrAssets() {
    return this.assetsForm.get('itemRowsAssets') as FormArray;
  }
  //liabilities section
  get formArrLiabilities() {
    return this.liabilitiesForm.get('itemRowsLiabilities') as FormArray;
  }
  //real estate section
  get formArrRealEstates() {
    return this.realEstateForm.get('itemRowsRealEstates') as FormArray;
  }

  addAnotherApplicant() {
    this.addAddressRelationship(this.formApplicant.length)
    this.formApplicant.push(this.initaddAnotherApplicant());
    this.formApplicantFamily.push(this.initaddAnotherApplicantFamily());
    //this.formPrimaryEmployment.push(this.initaddPrimaryEmployment());
    this.formApplicantEmployment.push(this.initaddAnotherApplicantEmployment());
    this.formApplicantIncome.push(this.initItemRowsBlank());
    this.indexx = this.formApplicant.length-1;
    this.signupSlider.resize();
    this.signupSlider.update();
  }
  addPreviousAddress() {
    this.formPreviousAddress.push(this.initaddPreviousAddress());
    this.indexx = this.formPreviousAddress.length-1;
    this.signupSlider.resize();
    this.signupSlider.update();
  }
  addPreviousEmployment() {
    this.formPrimaryEmployment.push(this.initaddPrimaryEmployment());
    this.indexx = this.formPrimaryEmployment.length-1;
  }
  removePreviousEmployment(key) {
    if(key > -1){
      for(var i = this.formPrimaryEmployment.length; i > 0; i--){
        if(i > key){
          this.formPrimaryEmployment.removeAt(i);
        }
      }
    }else{
      this.formPrimaryEmployment.removeAt(key);
    }
  }
  removePreviousAddress(key) {
    if(key > -1){
      for(var i = this.formPreviousAddress.length; i > 0; i--){
        if(i > key){
          this.formPreviousAddress.removeAt(i);
        }
      }
    }else{
      this.formPreviousAddress.removeAt(key);
    }
    this.signupSlider.resize();
    this.signupSlider.update();
  }
  addIncomes() {
    this.formArr.push(this.initItemRows());
    this.indexx = this.formArr.controls.length-1;
    this.signupSlider.resize();
    this.signupSlider.update();
  }
  addIncomesAdditional(index) {
    this.formApplicantIncome.controls[index]['controls']['itemRows'].push(this.initItemRows());
    this.signupSlider.resize();
    this.signupSlider.update();
  }
  addAssets() {
    this.formArrAssets.push(this.initItemRowsAssets());
    this.indexx = this.formArrAssets.controls.length-1;
    this.signupSlider.resize();
    this.signupSlider.update();
  }
  addLiabilities() {
    this.formArrLiabilities.push(this.initItemRowsLiabilities());
    this.indexx = this.formArrLiabilities.controls.length-1;
    this.signupSlider.resize();
    this.signupSlider.update();
  }
  updateSDF(postData){
    this.usersCollection.doc(postData.contact_uid).get().then(function(doc) {
    })
  }
  addressOfApplicant(event, index){
    this.showPrimaryApplicantAddress = 0;
    this.showAdditional_address = index;
    this.signupSlider.resize();
    this.signupSlider.update();
  }
  primaryApplicantAddress(event){
    this.showPrimaryApplicantAddress = 1;
    this.showAdditional_address = -1;
    this.signupSlider.resize();
    this.signupSlider.update();
  }

  primaryApplicantFamily(event, index){
    this.showPrimaryApplicantFamily = 1;
    this.showAdditionalFamily = -1;
    this.signupSlider.resize();
    this.signupSlider.update();
  }
  familyOfApplicant(event, index){
    this.showPrimaryApplicantFamily = 0;
    this.showAdditionalFamily = index;
    this.signupSlider.resize();
    this.signupSlider.update();
  }
  primaryApplicantEmployement(event){
    this.showPrimaryApplicantEmployement = 1;
    this.showAdditional_employement = -1;
    this.signupSlider.resize();
    this.signupSlider.update();
  }
  employementOfApplicant(event, index){
    this.showPrimaryApplicantEmployement = 0;
    this.showAdditional_employement = index;
    this.signupSlider.resize();
    this.signupSlider.update();
  }
  addAddressRelationship(index){
    this.formArrApplicantAddress.push(this.initItemApplicantAddress(index));
    this.signupSlider.resize();
    this.signupSlider.update();
  }
  addRemoveValidation(event, index){
    if(event == false){
      this.formArrApplicantAddress.controls[index]['controls'].addi_address_type.setValidators(Validators.required);
      this.formArrApplicantAddress.controls[index]['controls'].addi_address_type.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_address_format.setValidators(Validators.required);
      this.formArrApplicantAddress.controls[index]['controls'].addi_address_format.updateValueAndValidity();

      if(this.formArrApplicantAddress.value[index].addi_address_format == "standard" || this.formArrApplicantAddress.value[index].addi_address_format == "nonStandard"){
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_number.setValidators(Validators.required);
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_number.updateValueAndValidity();
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_name.setValidators(Validators.required);
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_name.updateValueAndValidity();
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_type.setValidators(Validators.required);
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_type.updateValueAndValidity();
      }else{
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_number.setValidators(null);
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_number.updateValueAndValidity();
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_name.setValidators(null);
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_name.updateValueAndValidity();
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_type.setValidators(null);
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_type.updateValueAndValidity();
      }
      this.formArrApplicantAddress.controls[index]['controls'].addi_city.setValidators(Validators.required);
      this.formArrApplicantAddress.controls[index]['controls'].addi_city.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_state.setValidators(Validators.required);
      this.formArrApplicantAddress.controls[index]['controls'].addi_state.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_postcode.setValidators(Validators.required);
      this.formArrApplicantAddress.controls[index]['controls'].addi_postcode.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_country.setValidators(Validators.required);
      this.formArrApplicantAddress.controls[index]['controls'].addi_country.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_housing_situation.setValidators(Validators.required);
      this.formArrApplicantAddress.controls[index]['controls'].addi_housing_situation.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_move_in_date.setValidators(Validators.required);
      this.formArrApplicantAddress.controls[index]['controls'].addi_move_in_date.updateValueAndValidity();
    }else{
      this.formArrApplicantAddress.controls[index]['controls'].addi_address_type.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_address_type.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_address_format.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_address_format.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_number.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_number.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_name.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_name.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_type.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_type.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_number.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_number.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_name.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_name.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_type.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_type.updateValueAndValidity();

      this.formArrApplicantAddress.controls[index]['controls'].addi_city.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_city.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_state.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_state.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_postcode.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_postcode.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_country.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_country.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_housing_situation.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_housing_situation.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_move_in_date.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_move_in_date.updateValueAndValidity();
    }
  }
  addPreviousAddressRelationship(event, index, position) {
    var getDate = event.target.value;
    var datesplit = getDate.split("/");
    if(datesplit.length == 3){
      var newDate = new Date().getTime()
      var oldDate = new Date(datesplit[2]+'-'+datesplit[1]+'-'+datesplit[0]+'T00:00:00Z')
      oldDate.setMonth(oldDate.getMonth() + 36);
      var oldDate1 = oldDate.getTime()
      if(newDate > oldDate1){
        this.removePreviousAddressRelationship1(position)
      }else{
        if((this.formPreviousAddress.length == 1 && index == "main")){
        }else{
          if(this.formPreviousAddress.length == (index+1)){
            this.addPreviousAddressRelationship1(index)
          }else if((this.formPreviousAddress.length == 0 && index == "main")){
            this.addPreviousAddressRelationship1(index)
          }
        }
      }
    }
    this.signupSlider.resize();
    this.signupSlider.update();
  }
  addPreviousAddressRelationship1(index) {
    this.formArrApplicantAddress.controls[index]['controls']['addPAddressRelationshipItem'].controls['addPreviousAddressRelationshipItem'].push(this.initItemRowsPreviousAddress());
    this.indexx = this.formPreviousAddress.length-1;
    this.signupSlider.resize();
    this.signupSlider.update();
  }
  removePreviousAddressRelationship1(key) {
    if(key > -1){
      for(var i = this.formPreviousAddress.length; i > 0; i--){
        if(i > key){
          this.formPreviousAddress.removeAt(i);
        }
      }
    }else{
      this.formPreviousAddress.removeAt(key);
    }
    this.signupSlider.resize();
    this.signupSlider.update();
  }  
  addRealEstates() {
    this.formArrRealEstates.push(this.initItemRowsRealEstate());
    this.signupSlider.resize();
    this.signupSlider.update();
  }
  addNewMortgageSplits(index) {
    this.formArrRealEstates.controls[index]['controls']['itemRowsMortgageSplits'].push(this.initItemRowsMortgageSplit());
    this.signupSlider.resize();
    this.signupSlider.update();
  }
  updateAndDeleteLoanSplit(parent_index: number, index: number, document_id: any, parent_document_id: any, status: any) {
    let alert = this.alertCtrl.create({
      title: 'Confirm delete Loan Split',
      message: 'Are you sure you want to delete this Loan Split?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {

                if(document_id !=""){
                  let deleted = 0;
                  if(status == 'delete'){
                    deleted = 1;
                  }
                  let postData = {
                    'document_id' : document_id,
                    'parent_document_id' : parent_document_id,
                    'collection': 'SDF_realestate',
                    'deleted': deleted,
                    'parent_index': parent_index,
                    'index': index,
                    'deleted_date' : new Date().getTime()
                  }
                  this.SdfFormService.deleteDocument(postData);
                  if(status == 'delete'){
                    if(this.userRole == "super_admin" && this.deleted_access == 1){
                      this.formArrRealEstates.controls[parent_index]['controls'].itemRowsMortgageSplits.value[index].deleted = 1;
                      this.formArrRealEstates.push(this.initItemRowsRealEstatesLoad(this.formArrRealEstates.controls[parent_index]['controls'].itemRowsMortgageSplits));
                    }
                    this.formArrRealEstates.controls[parent_index]['controls'].itemRowsMortgageSplits.removeAt(index);
                  }else{

                  }
                }else{
                  if(status == 'delete'){
                    this.formArrRealEstates.controls[parent_index]['controls'].itemRowsMortgageSplits.removeAt(index);
                  }
                }           
              }
          }
      ]
    });
    alert.present();
  }
  public changeOwnershipPercentage($event, index){
    //let real_state_current_name = $event.ngControl.name;
    //let get_secondary_percentage_asset_val = 0;    
    // let get_primary_percentage_asset_val = 0;
    // let get_primary_percentage_asset = this.realEstateForm.controls['itemRowsRealEstates'].controls[index].get('primary_percentage_asset');
    // get_primary_percentage_asset_val = get_primary_percentage_asset.value;
    // if(this.contact_second_uid == "" || this.contact_second_uid == null || this.contact_second_uid == undefined){
    //   let total_percentage_asset = Number(get_primary_percentage_asset_val) + Number(get_secondary_percentage_asset_val);
    //   if(total_percentage_asset != 100 ){
    //     if(real_state_current_name == 'primary_percentage_asset'){
    //       this.max_percent = 100 - Number(get_secondary_percentage_asset_val);
    //       get_primary_percentage_asset.setValidators([Validators.min(this.max_percent), Validators.max(this.max_percent)]);
    //       get_primary_percentage_asset.updateValueAndValidity();
    //     }      
    //   }
    // }else{
    //   this.get_secondary_percentage_asset = this.realEstateForm.controls['itemRowsRealEstates'].controls[index].get('secondary_percentage_asset');
    //   get_secondary_percentage_asset_val = this.get_secondary_percentage_asset.value
    //   let total_percentage_asset = Number(get_primary_percentage_asset_val) + Number(get_secondary_percentage_asset_val);
    //   if(this.get_secondary_percentage_asset.value == "" || get_primary_percentage_asset.value == ""){}else{
    //     if(total_percentage_asset != 100 ){
    //       if(real_state_current_name == 'primary_percentage_asset'){
    //         this.max_percent = 100 - Number(get_secondary_percentage_asset_val);
    //         get_primary_percentage_asset.setValidators([Validators.min(this.max_percent), Validators.max(this.max_percent)]);
    //         get_primary_percentage_asset.updateValueAndValidity();
    //       }else{
    //         this.max_percent = 100 - Number(get_primary_percentage_asset_val);
    //         this.get_secondary_percentage_asset.setValidators([Validators.min(this.max_percent), Validators.max(this.max_percent)]);
    //         this.get_secondary_percentage_asset.updateValueAndValidity();
    //       }      
    //     }else{
    //       get_primary_percentage_asset.setValidators([Validators.min(get_primary_percentage_asset_val), Validators.max(get_primary_percentage_asset_val)]);
    //       get_primary_percentage_asset.updateValueAndValidity();
    //       this.get_secondary_percentage_asset.setValidators([Validators.min(get_secondary_percentage_asset_val), Validators.max(get_secondary_percentage_asset_val)]);
    //       this.get_secondary_percentage_asset.updateValueAndValidity();
    //     }
    //   }
    // }

  }
  updateAddress(inputText, index, type){
    let addressInput = document.getElementById("address_"+this.rand+'_'+index);
    let autocomplete = new google.maps.places.Autocomplete(addressInput, {
      componentRestrictions: { country: 'AU' }
    });
    autocomplete.inputId = addressInput;
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
        const place = autocomplete.getPlace();
        let address_format = this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.address_format.value;
        let full_address = this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.full_address.value.split(' ');
        let full_address1 = full_address[0].split('/');
        if(full_address1.length == 1){
          full_address1 = full_address[0].split('-');
        }
        for (let i=0; i < place.address_components.length; i++){
          if (place.address_components[i].types[0] == "street_number") {
            if(place.address_components[i].long_name.search('/') >= 0 || place.address_components[i].long_name.search('-') >= 0){
              this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.street_number.setValue(place.address_components[i].long_name);
            }else if(full_address1.length > 1){
              if(address_format == 'nonStandard'){
                this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.street_number.setValue(full_address[0]);
                this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.unit_number.setValue(full_address1[0]);
              }else{
                this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.street_number.setValue(full_address[0]);
                this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.unit_number.setValue(full_address1[0]);
              }
            }else{
              this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.street_number.setValue(place.address_components[i].long_name);
            }
          }

          if (place.address_components[i].types[0] == "route") {
            let get_route = place.address_components[i].long_name;
            let type = place.address_components[i].long_name.split(" ");
            let typeName = type[type.length-1];
            let get_street_name = get_route.split(" "+typeName).join("");
            this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.street_name.setValue(get_street_name);
            this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.street_type.setValue(typeName.toUpperCase());

          }
          if (place.address_components[i].types[0] == "locality") {
            this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.city.setValue(place.address_components[i].long_name);
          }
          if (place.address_components[i].types[0] == "administrative_area_level_1") {
            this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.state.setValue(place.address_components[i].short_name);
          }
          if (place.address_components[i].types[0] == "country") {
            this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.country.setValue(place.address_components[i].long_name);
          }
          if (place.address_components[i].types[0] == "postal_code") {
            this.realEstateForm.controls['itemRowsRealEstates']['controls'][index].controls.postcode.setValue(place.address_components[i].long_name);
          }
        }
        this.signupSlider.update();
    });
  }
  uploadImage(event, uid, i, i1) {
    const thiss = this;
    if (event.target.files.length > 0) {
      Object.keys(event.target.files).forEach(function(key) {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[key]);
        reader.onload = (e:any) => {
          const fileraw = event.target.files[key];
          const filePath = '/sallary_payslip/' + uid + '/' + (Math.floor(1000 + Math.random() * 9000) + 1);
          const result = thiss.SaveImageRef(filePath, fileraw);
          const ref = result.ref;
          if(key == '0'){
            thiss.percentage_0 = result.task.percentageChanges();
          }else if(key == '1'){
            thiss.percentage_1 = result.task.percentageChanges();
          }else if(key == '2'){
            thiss.percentage_2 = result.task.percentageChanges();
          }else if(key == '3'){
            thiss.percentage_3 = result.task.percentageChanges();
          }else if(key == '4'){
            thiss.percentage_4 = result.task.percentageChanges();
          }else if(key == '5'){
            thiss.percentage_5 = result.task.percentageChanges();
          }
          
          result.task.then(a => {
            ref.getDownloadURL().subscribe(a => {
              if(i1 >= 0){
                if(key == '0'){
                  if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_0').value != ''){
                    if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_1').value != ''){
                      if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_2').value != ''){
                        if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_3').value != ''){
                          if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_4').value != ''){
                            thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_5.setValue(a);
                            thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_5.setValue(event.target.files[key].name);
                          }else{
                            thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_4.setValue(a);
                            thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_4.setValue(event.target.files[key].name);
                          }
                        }else{
                          thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_3.setValue(a);
                          thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_3.setValue(event.target.files[key].name);
                        }
                      }else{
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_2.setValue(a);
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_2.setValue(event.target.files[key].name);
                      }
                    }else{
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_1.setValue(a);
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_1.setValue(event.target.files[key].name);
                    }
                  }else{
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_0.setValue(a);
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_0.setValue(event.target.files[key].name);
                  }
                }else if(key == '1'){
                  if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_1').value != ''){
                    if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_2').value != ''){
                      if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_3').value != ''){
                        if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_4').value != ''){
                          thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_5.setValue(a);
                          thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_5.setValue(event.target.files[key].name);
                        }else{
                          thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_4.setValue(a);
                          thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_4.setValue(event.target.files[key].name);
                        }
                      }else{
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_3.setValue(a);
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_3.setValue(event.target.files[key].name);
                      }
                    }else{
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_2.setValue(a);
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_2.setValue(event.target.files[key].name);
                    }
                  }else{
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_1.setValue(a);
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_1.setValue(event.target.files[key].name);
                  }
                }else if(key == '2'){
                  if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_2').value != ''){
                    if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_3').value != ''){
                      if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_4').value != ''){
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_5.setValue(a);
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_5.setValue(event.target.files[key].name);
                      }else{
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_4.setValue(a);
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_4.setValue(event.target.files[key].name);
                      }
                    }else{
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_3.setValue(a);
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_3.setValue(event.target.files[key].name);
                    }
                  }else{
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_2.setValue(a);
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_2.setValue(event.target.files[key].name);
                  }
                }else if(key == '3'){
                  if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_3').value != ''){
                    if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_4').value != ''){
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_5.setValue(a);
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_5.setValue(event.target.files[key].name);
                    }else{
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_4.setValue(a);
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_4.setValue(event.target.files[key].name);
                    }
                  }else{
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_3.setValue(a);
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_3.setValue(event.target.files[key].name);
                  }
                }else if(key == '4'){
                  if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_4').value != ''){
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_5.setValue(a);
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_5.setValue(event.target.files[key].name);
                  }else{
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_4.setValue(a);
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_4.setValue(event.target.files[key].name);
                  }
                }else if(key == '5'){
                  thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_5.setValue(a);
                  thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_5.setValue(event.target.files[key].name);
                }
                
              }else{
                if(key == '0'){
                  if(thiss.formArr.controls[i].get('sallary_payslip_0').value != ''){
                    if(thiss.formArr.controls[i].get('sallary_payslip_1').value != ''){
                      if(thiss.formArr.controls[i].get('sallary_payslip_2').value != ''){
                        if(thiss.formArr.controls[i].get('sallary_payslip_3').value != ''){
                          if(thiss.formArr.controls[i].get('sallary_payslip_4').value != ''){
                            thiss.formArr.controls[i]['controls'].sallary_payslip_5.setValue(a);
                            thiss.formArr.controls[i]['controls'].sallary_payslip_name_5.setValue(event.target.files[key].name);
                          }else{
                            thiss.formArr.controls[i]['controls'].sallary_payslip_4.setValue(a);
                            thiss.formArr.controls[i]['controls'].sallary_payslip_name_4.setValue(event.target.files[key].name);
                          }
                        }else{
                          thiss.formArr.controls[i]['controls'].sallary_payslip_3.setValue(a);
                          thiss.formArr.controls[i]['controls'].sallary_payslip_name_3.setValue(event.target.files[key].name);
                        }
                      }else{
                        thiss.formArr.controls[i]['controls'].sallary_payslip_2.setValue(a);
                        thiss.formArr.controls[i]['controls'].sallary_payslip_name_2.setValue(event.target.files[key].name);
                      }
                    }else{
                      thiss.formArr.controls[i]['controls'].sallary_payslip_1.setValue(a);
                      thiss.formArr.controls[i]['controls'].sallary_payslip_name_1.setValue(event.target.files[key].name);
                    }  
                  }else{
                    thiss.formArr.controls[i]['controls'].sallary_payslip_0.setValue(a);
                    thiss.formArr.controls[i]['controls'].sallary_payslip_name_0.setValue(event.target.files[key].name);
                  }
                }else if(key == '1'){
                  if(thiss.formArr.controls[i].get('sallary_payslip_1').value != ''){
                    if(thiss.formArr.controls[i].get('sallary_payslip_2').value != ''){
                      if(thiss.formArr.controls[i].get('sallary_payslip_3').value != ''){
                        if(thiss.formArr.controls[i].get('sallary_payslip_4').value != ''){
                          thiss.formArr.controls[i]['controls'].sallary_payslip_5.setValue(a);
                          thiss.formArr.controls[i]['controls'].sallary_payslip_name_5.setValue(event.target.files[key].name);
                        }else{
                          thiss.formArr.controls[i]['controls'].sallary_payslip_4.setValue(a);
                          thiss.formArr.controls[i]['controls'].sallary_payslip_name_4.setValue(event.target.files[key].name);
                        }
                      }else{
                        thiss.formArr.controls[i]['controls'].sallary_payslip_3.setValue(a);
                        thiss.formArr.controls[i]['controls'].sallary_payslip_name_3.setValue(event.target.files[key].name);
                      }
                    }else{
                      thiss.formArr.controls[i]['controls'].sallary_payslip_2.setValue(a);
                      thiss.formArr.controls[i]['controls'].sallary_payslip_name_2.setValue(event.target.files[key].name);
                    }
                  }else{
                    thiss.formArr.controls[i]['controls'].sallary_payslip_1.setValue(a);
                    thiss.formArr.controls[i]['controls'].sallary_payslip_name_1.setValue(event.target.files[key].name);
                  } 
                }else if(key == '2'){
                  if(thiss.formArr.controls[i].get('sallary_payslip_2').value != ''){
                    if(thiss.formArr.controls[i].get('sallary_payslip_3').value != ''){
                      if(thiss.formArr.controls[i].get('sallary_payslip_4').value != ''){
                        thiss.formArr.controls[i]['controls'].sallary_payslip_5.setValue(a);
                        thiss.formArr.controls[i]['controls'].sallary_payslip_name_5.setValue(event.target.files[key].name);
                      }else{
                        thiss.formArr.controls[i]['controls'].sallary_payslip_4.setValue(a);
                        thiss.formArr.controls[i]['controls'].sallary_payslip_name_4.setValue(event.target.files[key].name);
                      }
                    }else{
                      thiss.formArr.controls[i]['controls'].sallary_payslip_3.setValue(a);
                      thiss.formArr.controls[i]['controls'].sallary_payslip_name_3.setValue(event.target.files[key].name);
                    }
                  }else{
                    thiss.formArr.controls[i]['controls'].sallary_payslip_2.setValue(a);
                    thiss.formArr.controls[i]['controls'].sallary_payslip_name_2.setValue(event.target.files[key].name);
                  }
                }else if(key == '3'){
                  if(thiss.formArr.controls[i].get('sallary_payslip_3').value != ''){
                    if(thiss.formArr.controls[i].get('sallary_payslip_4').value != ''){
                      thiss.formArr.controls[i]['controls'].sallary_payslip_5.setValue(a);
                      thiss.formArr.controls[i]['controls'].sallary_payslip_name_5.setValue(event.target.files[key].name);
                    }else{
                      thiss.formArr.controls[i]['controls'].sallary_payslip_4.setValue(a);
                      thiss.formArr.controls[i]['controls'].sallary_payslip_name_4.setValue(event.target.files[key].name);
                    }
                  }else{
                    thiss.formArr.controls[i]['controls'].sallary_payslip_3.setValue(a);
                    thiss.formArr.controls[i]['controls'].sallary_payslip_name_3.setValue(event.target.files[key].name);
                  }
                }else if(key == '4'){
                  if(thiss.formArr.controls[i].get('sallary_payslip_4').value != ''){
                    thiss.formArr.controls[i]['controls'].sallary_payslip_5.setValue(a);
                    thiss.formArr.controls[i]['controls'].sallary_payslip_name_5.setValue(event.target.files[key].name);
                  }else{
                    thiss.formArr.controls[i]['controls'].sallary_payslip_4.setValue(a);
                    thiss.formArr.controls[i]['controls'].sallary_payslip_name_4.setValue(event.target.files[key].name);
                  }
                }else if(key == '5'){
                  thiss.formArr.controls[i]['controls'].sallary_payslip_5.setValue(a);
                  thiss.formArr.controls[i]['controls'].sallary_payslip_name_5.setValue(event.target.files[key].name);
                }
              }
              thiss.signupSlider.resize();
              thiss.signupSlider.update();
            });
          });
        }, error => {
          console.log(error);
        }
      });
    }
  }
  SaveImageRef(filePath, file) {
    return {
      task: this.storage.upload(filePath, file), 
      ref: this.storage.ref(filePath)
    };
  }
  updatePreviousAddress(inputText, index, type){
    let addressInput = document.getElementById("address_"+index);
    let autocomplete = new google.maps.places.Autocomplete(addressInput,{
        componentRestrictions: { country: 'AU' }
    });
    autocomplete.inputId = addressInput;
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();
      let address_format = this.slideOneForm.controls['addPreviousAddressItem']['controls'][index].controls.previous_address_format.value;
      let full_address = this.slideOneForm.controls['addPreviousAddressItem']['controls'][index].controls.previous_full_address.value.split(' ');
      let full_address1 = full_address[0].split('/');
      if(full_address1.length == 1){
        full_address1 = full_address[0].split('-');
      }
      for (let i=0; i < place.address_components.length; i++){
        if (place.address_components[i].types[0] == "street_number") {
          if(place.address_components[i].long_name.search('/') >= 0 || place.address_components[i].long_name.search('-') >= 0){
            this.slideOneForm.controls['addPreviousAddressItem']['controls'][index].controls.previous_street_number.setValue(place.address_components[i].long_name);
          }else if(full_address1.length > 1){
            if(address_format == 'nonStandard'){
              this.slideOneForm.controls['addPreviousAddressItem']['controls'][index].controls.previous_street_number.setValue(full_address[0]);
              this.slideOneForm.controls['addPreviousAddressItem']['controls'][index].controls.previous_unit_number.setValue(full_address1[0]);
            }else{
              this.slideOneForm.controls['addPreviousAddressItem']['controls'][index].controls.previous_street_number.setValue(full_address[0]);
              this.slideOneForm.controls['addPreviousAddressItem']['controls'][index].controls.previous_unit_number.setValue(full_address1[0]);
            }
          }else{
            this.slideOneForm.controls['addPreviousAddressItem']['controls'][index].controls.previous_street_number.setValue(place.address_components[i].long_name);
          }
        }
        if (place.address_components[i].types[0] == "route") {
          let get_route = place.address_components[i].long_name;
          let type = place.address_components[i].long_name.split(" ");
          let typeName = type[type.length-1];
          let get_street_name = get_route.split(" "+typeName).join("");
          this.slideOneForm.controls['addPreviousAddressItem']['controls'][index].controls.previous_street_name.setValue(get_street_name);
          this.slideOneForm.controls['addPreviousAddressItem']['controls'][index].controls.previous_street_type.setValue(typeName.toUpperCase());
        }
        if (place.address_components[i].types[0] == "locality") {
          this.slideOneForm.controls['addPreviousAddressItem']['controls'][index].controls.previous_city.setValue(place.address_components[i].long_name);
        }
        if (place.address_components[i].types[0] == "administrative_area_level_1") {
          this.slideOneForm.controls['addPreviousAddressItem']['controls'][index].controls.previous_state.setValue(place.address_components[i].short_name);
        }
        if (place.address_components[i].types[0] == "country") {
          this.slideOneForm.controls['addPreviousAddressItem']['controls'][index].controls.previous_country.setValue(place.address_components[i].long_name);
        }
        if (place.address_components[i].types[0] == "postal_code") {
          this.slideOneForm.controls['addPreviousAddressItem']['controls'][index].controls.previous_postcode.setValue(place.address_components[i].long_name);
        }
      }
      this.signupSlider.update();
    });
  }
  updateSecondaryAddress(inputText, index){
    let addressInput = document.getElementById("additional_address_"+index);
    let autocomplete = new google.maps.places.Autocomplete(addressInput,{
        componentRestrictions: { country: 'AU' }
    });
    autocomplete.inputId = addressInput;
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();
      let address_format = this.slideOneForm.value.addAddressRelationshipItem[index].addi_address_format;
      let full_address = this.slideOneForm.value.addAddressRelationshipItem[index].addi_full_address.split(' ');
      let full_address1 = full_address[0].split('/');
      if(full_address1.length == 1){
        full_address1 = full_address[0].split('-');
      }
      for (let i=0; i < place.address_components.length; i++){
        if (place.address_components[i].types[0] == "street_number") {
          if(place.address_components[i].long_name.search('/') >= 0 || place.address_components[i].long_name.search('-') >= 0){
            this.slideOneForm.controls['addAddressRelationshipItem']['controls'][index].controls.addi_street_number.setValue(place.address_components[i].long_name);
          }else if(full_address1.length > 1){
            if(address_format == 'nonStandard'){
              this.slideOneForm.controls['addAddressRelationshipItem']['controls'][index].controls.addi_street_number.setValue(full_address[0]);
              this.slideOneForm.controls['addAddressRelationshipItem']['controls'][index].controls.addi_unit_number.setValue(full_address1[0]);
            }else{
              this.slideOneForm.controls['addAddressRelationshipItem']['controls'][index].controls.addi_street_number.setValue(full_address[0]);
              this.slideOneForm.controls['addAddressRelationshipItem']['controls'][index].controls.addi_unit_number.setValue(full_address1[0]);
            }
          }else{
            this.slideOneForm.controls['addAddressRelationshipItem']['controls'][index].controls.addi_street_number.setValue(place.address_components[i].long_name);
          }
        }
        if (place.address_components[i].types[0] == "route") {
          let get_route = place.address_components[i].long_name;
          let type = place.address_components[i].long_name.split(" ");
          let typeName = type[type.length-1];
          let get_street_name = get_route.split(" "+typeName).join("");
          this.slideOneForm.controls['addAddressRelationshipItem']['controls'][index].controls.addi_street_name.setValue(get_street_name);
          this.slideOneForm.controls['addAddressRelationshipItem']['controls'][index].controls.addi_street_type.setValue(typeName.toUpperCase());
        }
        if (place.address_components[i].types[0] == "locality") {
          this.slideOneForm.controls['addAddressRelationshipItem']['controls'][index].controls.addi_city.setValue(place.address_components[i].long_name);
        }
        if (place.address_components[i].types[0] == "administrative_area_level_1") {
          this.slideOneForm.controls['addAddressRelationshipItem']['controls'][index].controls.addi_state.setValue(place.address_components[i].short_name);
        }
        if (place.address_components[i].types[0] == "country") {
          this.slideOneForm.controls['addAddressRelationshipItem']['controls'][index].controls.addi_country.setValue(place.address_components[i].long_name);
        }
        if (place.address_components[i].types[0] == "postal_code") {
          this.slideOneForm.controls['addAddressRelationshipItem']['controls'][index].controls.addi_postcode.setValue(place.address_components[i].long_name);
        }
      }
      this.signupSlider.update();
    });
  }
  public setAsPrimary($event, i, type){
    this.addRemoveValidation($event._value, i);
    this.signupSlider.resize();
    this.signupSlider.update();
  }
  public changeType($event, type, i, i1){
    // if($event.target.value == 'Salary'){
    //   if(i1 == 'main'){
    //     this.formArr.controls[i].controls.sallary_payslip.setValidators(Validators.required);
    //     this.formArr.controls[i].controls.sallary_payslip.updateValueAndValidity();
    //   }else{
    //     this.formApplicantIncome.controls[i].controls['itemRows'].controls[i1].controls.sallary_payslip.setValidators(Validators.required);
    //     this.formApplicantIncome.controls[i].controls['itemRows'].controls[i1].controls.sallary_payslip.updateValueAndValidity();
    //   }
      
    // }else{
    //   if(i1 == 'main'){
    //     this.formArr.controls[i].controls.sallary_payslip.setValidators(null);
    //     this.formArr.controls[i].controls.sallary_payslip.updateValueAndValidity();
    //   }else{
    //     this.formApplicantIncome.controls[i].controls['itemRows'].controls[i1].controls.sallary_payslip.setValidators(null);
    //     this.formApplicantIncome.controls[i].controls['itemRows'].controls[i1].controls.sallary_payslip.updateValueAndValidity();
    //   }
      
    // }
    // this.signupSlider.resize();
    // this.signupSlider.update();

    this.new_val = $event.target.value;
    this.old_val = '';
    var property = '';
    if(type == 'type'){
      if(this.allIncomess.length > i){
        this.old_val = this.allIncomess[i].type;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Type';
    }
    if(this.new_val != this.old_val){
      this.income_details.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index' : i});
    }
    this.income_details.sort((a,b)=>a.index > b.index);
  }
  //end income section
  public changeAssetType($event, type, i){
    this.signupSlider.resize();
    this.signupSlider.update();

    this.new_val = $event.target.value;
    this.old_val = '';
    var property = '';
    if(type == 'asset_type'){
      if(this.allAssetss.length > i){
        this.old_val = this.allAssetss[i].asset_type;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Asset Type';
    }
    if(this.new_val != this.old_val){
      this.asset_details.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index' : i});
    }
    this.asset_details.sort((a,b)=>a.index > b.index);
  }
  //end assets section

  payslip_remove(postion, i, status){
    let alert = this.alertCtrl.create({
      title: 'Confirm remove payslip',
      message: 'Are you sure you want to remove this payslip ?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(status == "main"){
                  if(postion == 0){
                    this.formArr.controls[i]['controls'].sallary_payslip_0.setValue("");
                  }else if(postion == 1){
                    this.formArr.controls[i]['controls'].sallary_payslip_1.setValue("");
                  }else if(postion == 2){
                    this.formArr.controls[i]['controls'].sallary_payslip_2.setValue("");
                  }else if(postion == 3){
                    this.formArr.controls[i]['controls'].sallary_payslip_3.setValue("");
                  }else if(postion == 4){
                    this.formArr.controls[i]['controls'].sallary_payslip_4.setValue("");
                  }else if(postion == 5){
                    this.formArr.controls[i]['controls'].sallary_payslip_5.setValue("");
                  }
                  const docRef = firebase.firestore().collection('/SDF_income');
                  if(this.formArr.controls[i].get('document_id').value == '' || this.formArr.controls[i].get('document_id').value == null || this.formArr.controls[i].get('document_id').value == undefined){}else{
                    if(postion == 0){
                      docRef.doc(this.formArr.controls[i].get('document_id').value).update({
                        sallary_payslip_0 : ''
                      });
                    }else if(postion == 1){
                      docRef.doc(this.formArr.controls[i].get('document_id').value).update({
                        sallary_payslip_1 : ''
                      });
                    }else if(postion == 2){
                      docRef.doc(this.formArr.controls[i].get('document_id').value).update({
                        sallary_payslip_2 : ''
                      });
                    }else if(postion == 3){
                      docRef.doc(this.formArr.controls[i].get('document_id').value).update({
                        sallary_payslip_3 : ''
                      });
                    }else if(postion == 4){
                      docRef.doc(this.formArr.controls[i].get('document_id').value).update({
                        sallary_payslip_4 : ''
                      });
                    }else if(postion == 5){
                      docRef.doc(this.formArr.controls[i].get('document_id').value).update({
                        sallary_payslip_5 : ''
                      });
                    }
                  }
                }else if(status >= 0){  
                  if(postion == 0){
                    this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_0.setValue("");
                  }else if(postion == 1){
                    this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_1.setValue("");
                  }else if(postion == 2){
                    this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_2.setValue("");
                  }else if(postion == 3){
                    this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_3.setValue("");
                  }else if(postion == 4){
                    this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_4.setValue("");
                  }else if(postion == 5){
                    this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_5.setValue("");
                  } 
                  const docRef = firebase.firestore().collection('/SDF_income');
                  if(this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value == '' || this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value == null || this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value == undefined){}else{
                    if(postion == 0){
                      docRef.doc(this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value).update({
                        sallary_payslip_0 : ''
                      });
                    }else if(postion == 1){
                      docRef.doc(this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value).update({
                        sallary_payslip_1 : ''
                      });
                    }else if(postion == 2){
                      docRef.doc(this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value).update({
                        sallary_payslip_2 : ''
                      });
                    }else if(postion == 3){
                      docRef.doc(this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value).update({
                        sallary_payslip_3 : ''
                      });
                    }else if(postion == 4){
                      docRef.doc(this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value).update({
                        sallary_payslip_4 : ''
                      });
                    }else if(postion == 5){
                      docRef.doc(this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value).update({
                        sallary_payslip_5 : ''
                      });
                    }
                  }          
                }
              }
          }
      ]
    });
    alert.present();
  }

  deleteRestoreDocument(index: number, document_id: any, type: any, collection: any, status: any, index1: number) {
    let alert = this.alertCtrl.create({
      title: 'Confirm '+status+' '+type,
      message: 'Are you sure you want to '+status+' this '+type+' ?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(document_id !=""){
                  let deleted = 0;
                  if(status == 'delete'){
                    deleted = 1;
                  }
                  let postData = {
                    'document_id' : document_id,
                    'collection': collection,
                    'deleted': deleted,
                    'deleted_date' : new Date().getTime()
                  }
                  this.SdfFormService.deleteDocument(postData);
                  if(status == 'delete'){
                    if(type == 'income'){
                      if(index1 >= 0){
                        this.formApplicantIncome.controls[index]['controls'].itemRows.removeAt(index1);
                      }else{
                        this.formArr.removeAt(index);
                      }
                    }else if(type == 'assets'){
                      this.formArrAssets.removeAt(index);
                    }else if(type == 'liability'){
                      this.formArrLiabilities.removeAt(index);
                    }else if(type == 'real estate'){
                      this.formArrRealEstates.removeAt(index);
                    }
                  }
                }else{
                  if(status == 'delete'){
                    if(type == 'income'){
                      if(index1 >= 0){
                        this.formApplicantIncome.controls[index]['controls'].itemRows.removeAt(index1);
                      }else{
                        this.formArr.removeAt(index);
                      }
                    }else if(type == 'assets'){
                      this.formArrAssets.removeAt(index);
                    }else if(type == 'liability'){
                      this.formArrLiabilities.removeAt(index);
                    }else if(type == 'real estate'){
                      this.formArrRealEstates.removeAt(index);
                    }
                  }
                }                
              }
          }
      ]
    });
    alert.present();
  }


  public changeLiabilityType($event, index, type){
    let type_value = $event.target.value;
    var getRepayments = this.formArrLiabilities.at(index).get('repayments');
    if(type_value == 'Commercial Bill' || type_value == 'HECS' || type_value == 'Hire Purchase' || type_value == 'Maintenance' || type_value == 'Outstanding Taxation' || type_value == 'Other'){
      getRepayments.setValidators(null);
      getRepayments.updateValueAndValidity();
    }else{
      getRepayments.setValidators(Validators.required);
      getRepayments.updateValueAndValidity();
    }
    this.signupSlider.resize();
    this.signupSlider.update();

    this.new_val = $event.target.value;
    this.old_val = '';
    var property = '';
    if(type == 'liability_type'){
      if(this.allLiabilitiess.length > index){
        this.old_val = this.allLiabilitiess[index].liability_type;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'liability_type';
    }
    if(this.new_val != this.old_val){
      this.liability_details.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index' : index});
    }
    this.liability_details.sort((a,b)=>a.index > b.index);
  }
  //end liabilities section
  public slideNum(num){
    this.signupSlider.lockSwipes(false);
    this.signupSlider.slideTo(num);
    this.signupSlider.lockSwipes(true);
  }
  codeInput(event) {
    //48 - 57
    let pass = /[4][8-9]{1}/.test(event.charCode) || /[5][0-7]{1}/.test(event.charCode);
    if (!pass) {
      return false;
    }
  }

  phoneInput(event) {
    //48 - 57
    let pass = /[4][8-9]{1}/.test(event.charCode) || /[5][0-7]{1}/.test(event.charCode);
    if (!pass) {
      return false;
    }
  }
  setFormatNumber(event, index) {
    var mobile_phone = '';
    if(index >= 0){
      mobile_phone = this.slideOneForm.controls['addAnotherApplicantItem'].value[index].secondary_mobile_phone
      mobile_phone = mobile_phone.split(" ").join("");
      let firstFour = mobile_phone.slice(0, 4);
      let number = mobile_phone.slice(4, 10);
      number = firstFour + ' ' + number.slice(0, 3) + ' ' + number.slice(3);
      this.formApplicant.controls[index]['controls'].secondary_mobile_phone.setValue(number.trim());
    }else{
      mobile_phone = this.slideOneForm.controls.mobile_phone.value;
      mobile_phone = mobile_phone.split(" ").join("");
      let firstFour = mobile_phone.slice(0, 4);
      let number = mobile_phone.slice(4, 10);
      number = firstFour + ' ' + number.slice(0, 3) + ' ' + number.slice(3);
      this.slideOneForm.controls.mobile_phone.setValue(number.trim());
    }
  }
  onPaste(event) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    pastedText = pastedText.split(" ").join("");
    let firstFour = pastedText.slice(0, 4);
    let number = pastedText.slice(4, 10);
    number = firstFour + ' ' + number.slice(0, 3) + ' ' + number.slice(3);
    this.slideOneForm.controls.mobile_phone.setValue('');
    this.slideOneForm.controls.mobile_phone.setValue(number.trim());
  }
  stringGen(len) {
    var text = "";
    var charset = "abcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < len; i++)
      text += charset.charAt(Math.floor(Math.random() * charset.length));
    return text;
  }
  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err,
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }
  formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
      const negativeSign = amount < 0 ? "-" : "";
      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;
      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands);
    } catch (e) {
      //console.log(e)
    }
  }
  doClick(){
    this.viewCtrl.dismiss();
  }
  deleteSecondaryApplicant(index: number, document_id: any, uid: any, SDF_form_document_id: any) {
    let alert = this.alertCtrl.create({
      title: 'Confirm delete Applicant',
      message: 'Are you sure you want to delete this Applicant?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(document_id =="" || document_id ==null || document_id ==undefined){
                  this.formApplicant.removeAt(index);
                  this.formArrApplicantAddress.removeAt(index);
                  this.formApplicantEmployment.removeAt(index);
                  this.formApplicantFamily.removeAt(index);
                }else{
                  this.loadingProvider.startLoading();
                  let postData = {
                    'document_id' : document_id,
                    'SDF_form_document_id' : SDF_form_document_id,
                    'uid' : uid,
                    'deleted_date' : new Date().getTime()
                  }
                  this.SdfFormService.deleteAdditionalApplicant(postData);
                  this.formApplicant.removeAt(index);
                  this.formArrApplicantAddress.removeAt(index);
                  this.formApplicantEmployment.removeAt(index);
                  this.formApplicantFamily.removeAt(index);
                  this.loadingProvider.stopLoading();
                }  
                this.signupSlider.resize();
                this.signupSlider.update();              
              }
          }
      ]
    });
    alert.present();
  }
  getCurrentAddressDate(event, key, con_type, index){
    var getDate = event.target.value;
    var datesplit = getDate.split("/");
    if(datesplit.length == 3){
      var newDate = new Date().getTime()
      var oldDate = new Date(datesplit[2]+'-'+datesplit[1]+'-'+datesplit[0]+'T00:00:00Z')
      oldDate.setMonth(oldDate.getMonth() + 36);
      var oldDate1 = oldDate.getTime();
      if(con_type == 'primary'){
        if(newDate > oldDate1){
          this.removePreviousAddress(key)
        }else{
          if((this.formPreviousAddress.length == 1 && key == "main")){
          }else{
            if(this.formPreviousAddress.length == (key+1)){
              this.addPreviousAddress()
            }else if((this.formPreviousAddress.length == 0 && key == "main")){
              this.addPreviousAddress()
            }
          }
        }
      }else if(con_type == 'additional'){
        // if(newDate > oldDate1){
        //   this.removePreviousAddressRelationship1(key)
        // }else{
        //   if((this.formPreviousAddress.length == 1 && key == "main")){
        //   }else{
        //     if(this.formPreviousAddress.length == (key+1)){
        //       this.addPreviousAddressRelationship1(index)
        //     }else if((this.formPreviousAddress.length == 0 && key == "main")){
        //       this.addPreviousAddressRelationship1(index)
        //     }
        //   }
        // }
      }
    }
    this.signupSlider.resize();
    this.signupSlider.update();
  }
  getRoleStartDate(event, key, con_type, index: 0){
    var getDate = event.target.value;
    var datesplit = getDate.split("/");
    if(datesplit.length == 3){
      var newDate = new Date().getTime()
      var oldDate = new Date(datesplit[2]+'-'+datesplit[1]+'-'+datesplit[0]+'T00:00:00Z')
      oldDate.setMonth(oldDate.getMonth() + 36);
      var oldDate1 = oldDate.getTime();
      if(con_type == 'primary'){
        if(newDate > oldDate1){
          this.removePreviousEmployment(key)
          this.signupSlider.resize();
          this.signupSlider.update();  
        }else{
          if(this.formPrimaryEmployment.length == 0){
            this.addPreviousEmployment()
            this.signupSlider.resize();
            this.signupSlider.update();  
          }
        }
      }else if(con_type == 'additional'){
        if(newDate > oldDate1){
          this.formApplicantEmployment.controls[index]['controls'].previousEmploymentItem.removeAt(key);
          this.signupSlider.resize();
          this.signupSlider.update();  
        }else{
          if(this.formApplicantEmployment.controls[index]['controls'].previousEmploymentItem.length == 0){
            this.formApplicantEmployment.controls[index]['controls'].previousEmploymentItem.push(this.initaddPrimaryEmployment())
            this.signupSlider.resize();
            this.signupSlider.update();  
          }
        }
      }
    }
  }
  getPlaceAutocomplete(){
    const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement,
    {
        componentRestrictions: { country: 'AU' }
    });
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
        const place = autocomplete.getPlace();
        let address_format = this.slideOneForm.controls.address_format.value;
        let full_address = this.slideOneForm.controls.full_address.value.split(' ');
        let full_address1 = full_address[0].split('/');
        if(full_address1.length == 1){
          full_address1 = full_address[0].split('-');
        }
        for (let i=0; i < place.address_components.length; i++){

          this.new_val = '';
          this.old_val = '';
           
          if (place.address_components[i].types[0] == "street_number") {
            if(place.address_components[i].long_name.search('/') >= 0 || place.address_components[i].long_name.search('-') >= 0){
              this.slideOneForm.controls.street_number.setValue(place.address_components[i].long_name);
            }else if(full_address1.length > 1){
              if(address_format == 'nonStandard'){
                this.slideOneForm.controls.street_number.setValue(full_address[0]);
                this.slideOneForm.controls.unit_number.setValue(full_address1[0]);
              }else{
                this.slideOneForm.controls.street_number.setValue(full_address[0]);
                this.slideOneForm.controls.unit_number.setValue(full_address1[0]);
              }
            }else{
              this.slideOneForm.controls.street_number.setValue(place.address_components[i].long_name);
            }

            this.old_val = (this.applicant_details.street_number == undefined) ? '' : this.applicant_details.street_number;
            this.new_val = place.address_components[i].long_name;
            
            if(this.new_val != this.old_val){
              //this.change_log_string += 'street_number='+this.old_val+':'+this.new_val+';';
              this.change_log_string.push({'property' : 'Street Number', 'old_value' : this.old_val, 'new_value' : this.new_val});
            }
          }
          if (place.address_components[i].types[0] == "route") {
            let get_route = place.address_components[i].long_name;
            let type = place.address_components[i].long_name.split(" ");
            let typeName = type[type.length-1];
            let get_street_name = get_route.split(" "+typeName).join("");
            this.slideOneForm.controls.street_name.setValue(get_street_name);
            this.slideOneForm.controls.street_type.setValue(typeName.toUpperCase());

            this.old_val = (this.applicant_details.street_name == undefined) ? '' : this.applicant_details.street_name;
            this.new_val = get_street_name;            
            if(this.new_val != this.old_val){
              //this.change_log_string += 'street_name='+this.old_val+':'+this.new_val+';';
              this.change_log_string.push({'property' : 'Street Name', 'old_value' : this.old_val, 'new_value' : this.new_val});
            }

            this.old_val = (this.applicant_details.street_type == undefined) ? '' : this.applicant_details.street_type;
            this.new_val = typeName.toUpperCase();
            if(this.new_val != this.old_val){
              //this.change_log_string += 'street_type='+this.old_val+':'+this.new_val+';';
              this.change_log_string.push({'property' : 'Street Type', 'old_value' : this.old_val, 'new_value' : this.new_val});
            }

          }
          if (place.address_components[i].types[0] == "locality") {
            this.slideOneForm.controls.city.setValue(place.address_components[i].long_name);
            this.old_val = (this.applicant_details.city == undefined) ? '' : this.applicant_details.city;
            this.new_val = place.address_components[i].long_name;
            
            if(this.new_val != this.old_val){
              //this.change_log_string += 'city='+this.old_val+':'+this.new_val+';';
              this.change_log_string.push({'property' : 'City', 'old_value' : this.old_val, 'new_value' : this.new_val});
            }
          }
          if (place.address_components[i].types[0] == "administrative_area_level_1") {
            this.slideOneForm.controls.state.setValue(place.address_components[i].short_name);
            this.old_val = (this.applicant_details.state == undefined) ? '' : this.applicant_details.state;
            this.new_val = place.address_components[i].short_name;
            
            if(this.new_val != this.old_val){
              //this.change_log_string += 'state='+this.old_val+':'+this.new_val+';';
              this.change_log_string.push({'property' : 'State', 'old_value' : this.old_val, 'new_value' : this.new_val});
            }
          }
          if (place.address_components[i].types[0] == "country") {
            this.slideOneForm.controls.country.setValue(place.address_components[i].long_name);
            this.old_val = (this.applicant_details.country == undefined) ? '' : this.applicant_details.country;
            this.new_val = place.address_components[i].long_name;
            
            if(this.new_val != this.old_val){
              //this.change_log_string += 'country='+this.old_val+':'+this.new_val+';';
              this.change_log_string.push({'property' : 'Country', 'old_value' : this.old_val, 'new_value' : this.new_val});
            }
          }
          if (place.address_components[i].types[0] == "postal_code") {
            this.slideOneForm.controls.postcode.setValue(place.address_components[i].long_name);
            this.old_val = (this.applicant_details.postcode == undefined) ? '' : this.applicant_details.postcode;
            this.new_val = place.address_components[i].long_name;
            
            if(this.new_val != this.old_val){
              //this.change_log_string += 'postcode='+this.old_val+':'+this.new_val+';';
              this.change_log_string.push({'property' : 'Postcode', 'old_value' : this.old_val, 'new_value' : this.new_val});
            }
          }
        }  
        this.signupSlider.update();
    });
  }

  initializeItems(): void {
    this.SdfFormService.getAllUserDate()
    .then((res) => {
      this.allUserData = res;
    }, (err) => {
      console.log(err);
    })
  }

  initializeItemsEmails(): void {
    this.emailList = this.allUserData;
  }



  getEmailList(evt, index){
    const searchTerm = evt.target.value;
    if (!searchTerm) {
      this.isItemAvailable = false;
      return;
    }

    this.emailList = this.allUserData.filter(currentUser => {
      this.isItemAvailable = true;
      //let fullName = currentUser.firstname+' '+currentUser.lastname;
      if (currentUser.email && searchTerm) {
        if (currentUser.email.indexOf(searchTerm) > -1) {
          return true;
        }
        return false;
      }
    })
    if(this.emailList.length == 0){
      this.isItemAvailable = false;
    }
  }

  hideAutoEmail(event){
    this.isItemAvailable = false;
  }

  fillAutoEmail(data, index){
    console.log('data', data);
    console.log('index', index);
    let thiss = this;
    let currentApplication = this.slideOneForm.controls.addAnotherApplicantItem['controls'][index],
      firstName = currentApplication.get('secondary_firstname'),
      middleName = currentApplication.get('secondary_middlename'),
      lastName = currentApplication.get('secondary_lastname'),
      email = currentApplication.get('secondary_email'),
      phone = currentApplication.get('secondary_mobile_phone'),
      dob = currentApplication.get('secondary_date_of_birth'),
      rel_to_pri_app = currentApplication.get('relationship_to_primary_applicant');

    firstName.setValue(data.firstname);
    middleName.setValue(data.middlename);
    lastName.setValue(data.lastname);
    email.setValue(data.email);
    phone.setValue(data.mobile_phone);
    dob.setValue(data.date_of_birth);
    rel_to_pri_app.setValue((data.relationship_to_primary_applicant == undefined) ? 'Life Partner' : data.relationship_to_primary_applicant);
    if(data.city == "" || data.city == null || data.city == undefined){
      data.addi_same_as_primary = 'true';
    }else{
      data.addi_same_as_primary = 'false';
    }
    this.formArrApplicantAddress.controls[index] = this.initItemApplicantAddressLoad(data);
    if((data.same_as_primary == undefined || data.same_as_primary == false) && data.city != "")
    this.addRemoveValidation('false', index);
    thiss.formApplicantFamily.controls[index] = thiss.initaddAnotherApplicantFamilyLoad(data);
    firebase.firestore().collection("employment").where("uid", "==", data.uid).get()
    .then(function(querySnapshotEmp) {
      querySnapshotEmp.forEach(function(empDoc) {
        thiss.formApplicantEmployment.controls[index] = thiss.initaddAnotherApplicantEmploymentLoad(empDoc.data());
        console.log('thiss.formApplicantEmployment.controls[index]', thiss.formApplicantEmployment.controls[index])
        thiss.changeEmploymentTypeaddi(empDoc.data().employementType, index);
        if(empDoc.data().employementType == 'payg'){
          thiss.currentEmployeedaddi(empDoc.data().currentlyEmployment, index);
        }

        // if(empDoc.data().primaryEmployment !=  undefined && empDoc.data().primaryEmployment.length > 0){
        //   let ii = 0;
        //   empDoc.data().primaryEmployment.forEach(uDatape => {
        //     thiss.formApplicantEmployment.controls[index]['controls'].previousEmploymentItem.push(thiss.initaddPrimaryEmploymentLoad(uDatape));
        //     thiss.changeEmploymentTypeAddiPrev(uDatape.employementType, index, ii);
        //     if(empDoc.data().employementType == 'payg'){
        //       thiss.currentEmployeedAddiPrev(uDatape.currentlyEmployment, index, ii);
        //     }
        //     ii++;
        //   });
        // }
      });
      if(querySnapshotEmp.empty){
        thiss.formApplicantEmployment.push(thiss.initaddAnotherApplicantEmployment());
      }

      thiss.slideThreeForm.controls['addEmploymentItem']['controls'].forEach(formGroup => {
        thiss.markFormGroupTouched(formGroup);
      });
    });

    thiss.editgetIncomes(data.uid).subscribe((editgetIncomes)=>{
      if(editgetIncomes.length > 0 && thiss.formApplicantIncome.controls[index].value.itemRows.length == 0){
        editgetIncomes.forEach(uData => {
          thiss.formApplicantIncome.controls[index]['controls'].itemRows.push(thiss.initItemRowsIncomesLoad(uData));
        })
      }
    });
    thiss.editgetLiabilities(data.uid).subscribe((editgetLiabilities)=>{
      if(editgetLiabilities.length > 0){
        editgetLiabilities.forEach(uData => {
          console.log('uData', uData);
          thiss.formArrLiabilities.push(thiss.initItemRowsLiabilitiesLoad(uData));
          var getRepayments = thiss.formArrLiabilities.at((thiss.formArrLiabilities.length-1)).get('repayments');
          var type_value = uData.liability_type;
          if(type_value == 'Commercial Bill' || type_value == 'HECS' || type_value == 'Hire Purchase' || type_value == 'Maintenance' || type_value == 'Outstanding Taxation' || type_value == 'Other'){
            getRepayments.setValidators(null);
            getRepayments.updateValueAndValidity();
          }else{
            getRepayments.setValidators(Validators.required);
            getRepayments.updateValueAndValidity();
          }
        })
      }
    });

    thiss.formApplicant.updateValueAndValidity();
    thiss.formApplicantFamily.updateValueAndValidity();
    thiss.formApplicantEmployment.updateValueAndValidity();
    thiss.isItemAvailable = false;

    // this.slideOneForm.updateOn
    // this.signupSlider.update();
    $('.hintEmail').hide();
  }

  hideEmailList(){
    this.emailList = [];
  }

  changeLog(event, index: any){
    let thiss = this;
    var property = event.ngControl.name;
    this.new_val = event._value;
    this.old_val = '';
    var new_property = '';

    if(index == 'main'){
      if(property == 'firstname'){
        this.old_val = (this.applicant_details.firstname == undefined) ? '' : this.applicant_details.firstname;
        new_property = 'Firstname';
        this.firstname = this.new_val;
      }
      if(property == 'middlename'){
        this.old_val = (this.applicant_details.middlename == undefined) ? '' : this.applicant_details.middlename;
        new_property = 'Middlename';
      }
      if(property == 'lastname'){
        this.old_val = (this.applicant_details.lastname == undefined) ? '' : this.applicant_details.lastname;
        new_property = 'Lastname';
        this.lastname = this.new_val;
      }
      if(property == 'email'){
        this.old_val = (this.applicant_details.email == undefined) ? '' : this.applicant_details.email;
        new_property = 'Email';
        thiss.checkContact = 0;
        firebase.firestore().collection("users").where("email", "==", this.new_val).get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(priCon) {
            if(priCon.data().roles.contact == true){
              thiss.checkContact = 0;
            }else{
              thiss.checkContact = 1;
            }
          })
        })
        this.signupSlider.resize();
        this.signupSlider.update();
      }
      if(property == 'mobile_phone'){
        this.old_val = (this.applicant_details.mobile_phone == undefined) ? '' : this.applicant_details.mobile_phone;
        new_property = 'Mobile Phone';
      }
      if(property == 'primayr_goal_intention'){
        this.old_val = (this.applicant_details.primayr_goal_intention == undefined) ? '' : this.applicant_details.primayr_goal_intention;
        new_property = 'Primary Goal Intention';
      }
      if(property == 'floor_number'){
        this.old_val = (this.applicant_details.floor_number == undefined) ? '' : this.applicant_details.floor_number;
        new_property = 'Floor Number';
      }
      if(property == 'unit_number'){
        this.old_val = (this.applicant_details.unit_number == undefined) ? '' : this.applicant_details.unit_number;
        new_property = 'Unit Number';
      }
      if(property == 'building_name'){
        this.old_val = (this.applicant_details.building_name == undefined) ? '' : this.applicant_details.building_name;
        new_property = 'Building Name';
      }
      if(property == 'street_number'){
        this.old_val = (this.applicant_details.street_number == undefined) ? '' : this.applicant_details.street_number;
        new_property = 'Street Number';
      }
      if(property == 'street_name'){
        this.old_val = (this.applicant_details.street_name == undefined) ? '' : this.applicant_details.street_name;
        new_property = 'Street Name';
      }
      if(property == 'city'){
        this.old_val = (this.applicant_details.city == undefined) ? '' : this.applicant_details.city;
        new_property = 'City';
      }
      if(property == 'postcode'){
        this.old_val = (this.applicant_details.postcode == undefined) ? '' : this.applicant_details.postcode;
        new_property = 'Postcode';
      }
      if(property == 'poboxlabel'){
        this.old_val = (this.applicant_details.poboxlabel == undefined) ? '' : this.applicant_details.poboxlabel;
        new_property = 'PO Box Label';
      }
      if(property == 'first_child_age'){
        this.old_val = (this.applicant_details.first_child_age == undefined) ? '' : this.applicant_details.first_child_age;
        new_property = 'First Child Age';
      }
      if(property == 'second_child_age'){
        this.old_val = (this.applicant_details.second_child_age == undefined) ? '' : this.applicant_details.second_child_age;
        new_property = 'Second Child Age';
      }
      if(property == 'third_child_age'){
        this.old_val = (this.applicant_details.third_child_age == undefined) ? '' : this.applicant_details.third_child_age;
        new_property = 'Third Child Age';
      }
      if(property == 'fourth_child_age'){
        this.old_val = (this.applicant_details.fourth_child_age == undefined) ? '' : this.applicant_details.fourth_child_age;
        new_property = 'Fourth Child Age';
      }
      if(property == 'fifth_child_age'){
        this.old_val = (this.applicant_details.fifth_child_age == undefined) ? '' : this.applicant_details.fifth_child_age;
        new_property = 'Fifth Child Age';
      }
      if(property == 'sixth_child_age'){
        this.old_val = (this.applicant_details.sixth_child_age == undefined) ? '' : this.applicant_details.sixth_child_age;
        new_property = 'Sixth Child Age';
      }
      if(property == 'your_occupation'){
        this.old_val = (this.employment_details.your_occupation == undefined) ? '' : this.employment_details.your_occupation;
        new_property = 'Your Occupation';
      }
      if(property == 'start_date'){
        this.old_val = (this.employment_details.start_date == undefined) ? '' : this.employment_details.start_date;
        new_property = 'Employment start date';
      }
      if(property == 'business_name'){
        this.old_val = (this.employment_details.business_name == undefined) ? '' : this.employment_details.business_name;
        new_property = 'Business Name';
      }
      if(property == 'type_of_entity'){
        this.old_val = (this.employment_details.type_of_entity == undefined) ? '' : this.employment_details.type_of_entity;
        new_property = 'Type of Entity';
      }
      if(property == 'abn_acn'){
        this.old_val = (this.employment_details.abn_acn == undefined) ? '' : this.employment_details.abn_acn;
        new_property = 'abn_acn';
      }
      if(property == 'nature_of_business'){
        this.old_val = (this.employment_details.nature_of_business == undefined) ? '' : this.employment_details.nature_of_business;
        new_property = 'Nature of Business';
      }
    }else{
      if(property == 'secondary_email'){
        this.old_val = (this.secondary_details.secondary_email == undefined) ? '' : this.secondary_details.secondary_email;
        new_property = 'Email';
        thiss.checkAddiContact.push({'status': 0});
        thiss.checkAddiContact[index].status = 0;
        thiss.checkAddiContactStatus = 0;
        firebase.firestore().collection("users").where("email", "==", this.new_val).get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(priCon) {
            if(priCon.data().roles.contact == true){
              thiss.checkAddiContact[index].status = 0;
            }else{
              thiss.checkAddiContact[index].status = 1;
              thiss.checkAddiContactStatus = 1;
            }
          })
        })
        this.signupSlider.resize();
        this.signupSlider.update();
      }

    }

    
    
    if(this.new_val != this.old_val){
      //this.change_log_string += property+'='+this.old_val+':'+this.new_val+';';
      this.change_log_string.push({'property' : new_property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': index, 'index2': index});
    }
  }
  collectLogData(event, type, index){
    this.new_val = event.target.value;
    this.old_val = '';
    var property = '';
    if(type == 'address_type'){
      this.old_val = (this.applicant_details.address_type == undefined) ? '' : this.applicant_details.address_type;
      property = 'Address Type';
    }
    if(type == 'street_type'){
      this.old_val = (this.applicant_details.street_type == undefined) ? '' : this.applicant_details.street_type;
      property = 'Street Type';
    }
    if(type == 'state'){
      this.old_val = (this.applicant_details.state == undefined) ? '' : this.applicant_details.state;
      property = 'State';
    }
    if(type == 'country'){
      this.old_val = (this.applicant_details.country == undefined) ? '' : this.applicant_details.country;
      property = 'Country';
    }
    if(type == 'housing_situation'){
      this.old_val = (this.applicant_details.housing_situation == undefined) ? '' : this.applicant_details.housing_situation;
      property = 'Housing Situation';
    }
    if(type == 'move_in_date'){
      this.old_val = (this.applicant_details.move_in_date == undefined) ? '' : this.applicant_details.move_in_date;
      property = 'Move in Date';
    }
    if(type == 'date_of_birth'){
      this.old_val = (this.applicant_details.date_of_birth == undefined) ? '' : this.applicant_details.date_of_birth;
      property = 'Date of Birth';
    }

    if(this.new_val != this.old_val){
      this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': index, 'index2': index});
    }
  }
  changeLogData(event, type, index){
    if(event == undefined){
      return false;
    }
    this.new_val = event;
    this.old_val = '';
    var property = '';
    if(type == 'current_marital_status'){
      this.old_val = (this.applicant_details.current_marital_status == undefined) ? '' : this.applicant_details.current_marital_status;
      property = 'Current Marital Status';
    }
    if(type == 'gender'){
      this.old_val = (this.applicant_details.gender == undefined) ? '' : this.applicant_details.gender;
      property = 'Gender';
    }

    if(this.new_val != this.old_val){
      this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': index, 'index2': index});
    }
  }
  incomeLogData(event, type, index, index2){
    this.new_val = event.target.value.split("$").join("").split(",").join("");
    this.old_val = '';
    var property = '';
    if(type == 'amount'){
      if(this.allIncomess.length > index){
        this.old_val = (this.allIncomess[index].amount == undefined) ? '' : this.allIncomess[index].amount.split("$").join("").split(",").join("");
      }else{
        this.old_val = '';
      }
      property = 'Amount';
    }
    if(type == 'receive_overtime'){
      if(this.allIncomess.length > index){
        this.old_val = (this.allIncomess[index].receive_overtime == undefined) ? '' : this.allIncomess[index].receive_overtime.split("$").join("").split(",").join("");
      }else{
        this.old_val = '';
      }
      property = 'Receive Overtime';
    }
    if(type == 'receive_commissions_bounses'){
      if(this.allIncomess.length > index){
        this.old_val = (this.allIncomess[index].receive_commissions_bounses == undefined) ? '' : this.allIncomess[index].receive_commissions_bounses.split("$").join("").split(",").join("");
      }else{
        this.old_val = '';
      }
      property = 'Receive Commissions Bounses';
    }
    if(type == 'receive_moter_vehicle_allowance'){
      if(this.allIncomess.length > index){
        this.old_val = (this.allIncomess[index].receive_moter_vehicle_allowance == undefined) ? '' : this.allIncomess[index].receive_moter_vehicle_allowance.split("$").join("").split(",").join("");
      }else{
        this.old_val = '';
      }
      property = 'Receive Moter Vehicle Allowance';
    }
    if(type == 'salary_sacrifice'){
      if(this.allIncomess.length > index){
        this.old_val = (this.allIncomess[index].salary_sacrifice == undefined) ? '' : this.allIncomess[index].salary_sacrifice.split("$").join("").split(",").join("");
      }else{
        this.old_val = '';
      }
      property = 'Salary Sacrifice';
    }
    if(type == 'any_other_allowances'){
      if(this.allIncomess.length > index){
        this.old_val = (this.allIncomess[index].any_other_allowances == undefined) ? '' : this.allIncomess[index].any_other_allowances.split("$").join("").split(",").join("");
      }else{
        this.old_val = '';
      }
      property = 'Any Other Allowances';
    }
    if(this.new_val != this.old_val){
      this.income_details.push({'property' : property, 'old_value' : '$ '+this.formatMoney(this.old_val), 'new_value' : '$ '+this.formatMoney(this.new_val), 'index' : index, 'index2' : index2});
    }
    this.income_details.sort((a,b)=>a.index > b.index);
  }
  incomeDateLogData(event, type, index, index2){
    this.new_val = event.target.value;
    this.old_val = '';
    var property = '';
    if(type == 'date_commenced'){
      if(this.allIncomess.length > index){
        this.old_val = (this.allIncomess[index].date_commenced == undefined) ? '' : this.allIncomess[index].date_commenced;
      }else{
        this.old_val = '';
      }
      property = 'Date Commenced';
    }
    if(this.new_val != this.old_val){
      this.income_details.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index' : index, 'index2' : index2});
    }
    this.income_details.sort((a,b)=>a.index > b.index);
  }
  incomeLogData1(event, type, index, index2){
    this.new_val = event._value;
    this.old_val = '';
    var property = '';
    if(type == 'comments'){
      if(this.allIncomess.length > index){
        this.old_val = (this.allIncomess[index].comments == undefined) ? '' : this.allIncomess[index].comments;
      }else{
        this.old_val = '';
      }
      property = 'Comments';
    }
    if(this.new_val != this.old_val){
      this.income_details.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index' : index, 'index2' : index2});
    }
    this.income_details.sort((a,b)=>a.index > b.index);
  }
  collectIncomeLogData(event, type, index, index2){
    this.new_val = event.target.value;
    this.old_val = '';
    var property = '';
    if(type == 'frequency'){
      if(this.allIncomess.length > index){
        this.old_val = (this.allIncomess[index].frequency == undefined) ? '' : this.allIncomess[index].frequency;
      }else{
        this.old_val = '';
      }
      property = 'Frequency';
    }

    if(this.new_val != this.old_val){
      this.income_details.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index' : index, 'index2' : index2});
    }
  }
  assetLogData(event, type, index, index2 = 'main'){
    this.new_val = event.target.value.split("$").join("").split(",").join("");
    this.old_val = '';
    var property = '';
    if(type == 'asset_value'){
      if(this.allAssetss.length > index){
        this.old_val = this.allAssetss[index].asset_value.split("$").join("").split(",").join("");
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Asset Value';
    }
    
    if(this.new_val != this.old_val){
      this.asset_details.push({'property' : property, 'old_value' : '$ '+this.formatMoney(this.old_val), 'new_value' : '$ '+this.formatMoney(this.new_val), 'index' : index, 'index2' : index2});
    }
    this.asset_details.sort((a,b)=>a.index > b.index);
  }

  assetLogData1(event, type, index, index2 = 'main'){
    this.new_val = event._value;
    this.old_val = '';
    var property = '';
    if(type == 'percentage_asset'){
      if(this.allAssetss.length > index){
        this.old_val = this.allAssetss[index].percentage_asset;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Percentage Asset';
    }
    if(type == 'institution'){
      if(this.allAssetss.length > index){
        this.old_val = this.allAssetss[index].institution;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Institution';
    }
    if(type == 'account_name'){
      if(this.allAssetss.length > index){
        this.old_val = this.allAssetss[index].account_name;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Account Name';
    }
    if(type == 'bsb'){
      if(this.allAssetss.length > index){
        this.old_val = this.allAssetss[index].bsb;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'BSB';
    }
    if(type == 'account_no'){
      if(this.allAssetss.length > index){
        this.old_val = this.allAssetss[index].account_no;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Account Number';
    }
    if(type == 'year'){
      if(this.allAssetss.length > index){
        this.old_val = this.allAssetss[index].year;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Year';
    }
    if(type == 'make'){
      if(this.allAssetss.length > index){
        this.old_val = this.allAssetss[index].make;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Make';
    }
    if(type == 'description'){
      if(this.allAssetss.length > index){
        this.old_val = this.allAssetss[index].description;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Description';
    }
    if(this.new_val != this.old_val){
      this.asset_details.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index' : index, 'index2' : index2});
    }
    this.asset_details.sort((a,b)=>a.index > b.index);
  }

  collectAssetLogData(event, type, index, index2 = 'main'){
    this.new_val = event.target.value;
    this.old_val = '';
    var property = '';
    if(type == 'value_basis'){
      if(this.allAssetss.length > index){
        this.old_val = this.allAssetss[index].value_basis;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Value Basis';
    }

    if(type == 'type'){
      if(this.allAssetss.length > index){
        this.old_val = this.allAssetss[index].type;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Type';
    }

    if(this.new_val != this.old_val){
      this.asset_details.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index' : index, 'index2' : index2});
    }
  }

  liabilitiesLogData(event, type, index, index2 = 'main'){
    this.new_val = event.target.value.split("$").join("").split(",").join("");
    this.old_val = '';
    var property = '';
    if(type == 'current_balance'){
      if(this.allLiabilitiess.length > index){
        this.old_val = this.allLiabilitiess[index].current_balance.split("$").join("").split(",").join("");
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Current Balance';
    }
    if(type == 'limit'){
      if(this.allLiabilitiess.length > index){
        this.old_val = this.allLiabilitiess[index].limit.split("$").join("").split(",").join("");
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Limit';
    }
    if(type == 'repayments'){
      if(this.allLiabilitiess.length > index){
        this.old_val = this.allLiabilitiess[index].repayments.split("$").join("").split(",").join("");
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Repayments';
    }
    
    if(this.new_val != this.old_val){
      this.liability_details.push({'property' : property, 'old_value' : '$ '+this.formatMoney(this.old_val), 'new_value' : '$ '+this.formatMoney(this.new_val), 'index' : index, 'index2' : index2});
    }
    this.liability_details.sort((a,b)=>a.index > b.index);
  }

  liabilitiesLogData1(event, type, index, index2 = 'main'){
    this.new_val = event._value;
    this.old_val = '';
    var property = '';
    if(type == 'institution'){
      if(this.allLiabilitiess.length > index){
        this.old_val = this.allLiabilitiess[index].institution;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Institution';
    }
    if(type == 'account_name'){
      if(this.allLiabilitiess.length > index){
        this.old_val = this.allLiabilitiess[index].account_name;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Account Name';
    }
    if(type == 'bsb'){
      if(this.allLiabilitiess.length > index){
        this.old_val = this.allLiabilitiess[index].bsb;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'BSB';
    }
    if(type == 'account_no'){
      if(this.allLiabilitiess.length > index){
        this.old_val = this.allLiabilitiess[index].account_no;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Account Number';
    }
    if(type == 'description'){
      if(this.allLiabilitiess.length > index){
        this.old_val = this.allLiabilitiess[index].description;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Description';
    }
    if(this.new_val != this.old_val){
      this.liability_details.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index' : index, 'index2' : index2});
    }
    this.liability_details.sort((a,b)=>a.index > b.index);
  }

  collectLiabilitiesLogData(event, type, index, index2 = 'main'){
    this.new_val = event.target.value;
    this.old_val = '';
    var property = '';
    if(type == 'credit_cart_type'){
      if(this.allLiabilitiess.length > index){
        this.old_val = this.allLiabilitiess[index].credit_cart_type;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Credit Cart Type';
    }

    if(type == 'payment_type'){
      if(this.allLiabilitiess.length > index){
        this.old_val = this.allLiabilitiess[index].payment_type;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Payment Type';
    }

    if(this.new_val != this.old_val){
      this.liability_details.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index' : index, 'index2' : index2});
    }
  }

  clickToHomepage(){
    this.menuCtrl.close();
    var nav = this.app.getRootNav();
    if(this.userRole == 'contact'){
      nav.setRoot(ViewContactPage);
    }else{
      nav.setRoot(HomePage);
    }
  }

  realEstateLogData(event, type, index, split_index = -1){
    this.new_val = event.target.value.split("$").join("").split(",").join("");
    this.old_val = '';
    var property = '';
    if(type == 'available_redraw'){
      property = 'Funds in Offset or Redraw';
    }else if(type == 'gross_amount'){
      property = 'Gross Mortgage Amount';
    }else{
      property = type.split("_").join(" ").toUpperCase();
    }
    if(this.allRealEstatess != undefined){
      if(type == 'asset_value'){
        if(this.allRealEstatess.length > index && this.allRealEstatess[index].asset_value != undefined){
          this.old_val = (this.allRealEstatess[index].asset_value.split("$").join("").split(",").join("") == undefined) ? '' : this.allRealEstatess[index].asset_value.split("$").join("").split(",").join("");
        }else{
          this.old_val = '';
        }
        property = 'Asset Value';
      }
      if(type == 'gross_amount'){
        if(this.allRealEstatess.length > index && this.allRealEstatess[index].gross_amount != undefined){
          this.old_val = (this.allRealEstatess[index].gross_amount.split("$").join("").split(",").join("") == undefined) ? '' : this.allRealEstatess[index].gross_amount.split("$").join("").split(",").join("");
        }else{
          this.old_val = '';
        }
        property = 'Gross Mortgage Amount';
      }
      if(type == 'available_redraw'){
        if(this.allRealEstatess[index] > index && this.allRealEstatess[index].split.length > split_index){
          this.old_val = (this.allRealEstatess[index].split[split_index].available_redraw.split("$").join("").split(",").join("") == undefined) ? '' : this.allRealEstatess[index].split[split_index].available_redraw.split("$").join("").split(",").join("");
        }else{
          this.old_val = '';
        }
        property = 'Funds in Offset or Redraw';
      }

      if(type == 'current_balance'){
        if(this.allRealEstatess[index] > index && this.allRealEstatess[index].split.length > split_index){
          this.old_val = (this.allRealEstatess[index].split[split_index].current_balance.split("$").join("").split(",").join("") == undefined) ? '' : this.allRealEstatess[index].split[split_index].current_balance.split("$").join("").split(",").join("");
        }else{
          this.old_val = '';
        }
        property = 'Current Balance';
      }
      if(type == 'repayments'){
        if(this.allRealEstatess[index] > index && this.allRealEstatess[index].split.length > split_index){
          this.old_val = (this.allRealEstatess[index].split[split_index].repayments.split("$").join("").split(",").join("") == undefined) ? '' : this.allRealEstatess[index].split[split_index].repayments.split("$").join("").split(",").join("");
        }else{
          this.old_val = '';
        }
        property = 'Repayments';
      }
    }  
    if(this.new_val != this.old_val && property != ''){
      this.realEstate_details.push({'property' : property, 'old_value' : '$ '+this.formatMoney(this.old_val), 'new_value' : '$ '+this.formatMoney(this.new_val), 'index' : index, 'split_index' : split_index});
    }
    this.realEstate_details.sort((a,b)=>a.index > b.index);
  }

  realEstateLogData1(event, type, index, split_index = -1){
    this.new_val = event._value;
    this.old_val = '';
    var property = type.split("_").join(" ").toUpperCase();
    if(this.allRealEstatess != undefined){
      if(type == 'ownership_title_name'){
        if(this.allRealEstatess.length > index && this.allRealEstatess[index].ownership_title_name != undefined){
          this.old_val = (this.allRealEstatess[index].ownership_title_name == undefined) ? '' : this.allRealEstatess[index].ownership_title_name;
        }else{
          this.old_val = '';
        }
        property = 'Ownership Title Name';
      }
      if(type == 'primary_percentage_asset'){
        if(this.allRealEstatess.length > index && this.allRealEstatess[index].primary_percentage_asset != undefined){
          this.old_val = (this.allRealEstatess[index].primary_percentage_asset == undefined) ? '' : this.allRealEstatess[index].primary_percentage_asset;
        }else{
          this.old_val = '';
        }
        property = 'Primary Percentage';
      }
      if(type == 'secondary_percentage_asset'){
        if(this.allRealEstatess.length > index && this.allRealEstatess[index].secondary_percentage_asset != undefined){
          this.old_val = (this.allRealEstatess[index].secondary_percentage_asset == undefined) ? '' : this.allRealEstatess[index].secondary_percentage_asset;
        }else{
          this.old_val = '';
        }
        property = 'Secondary Percentage';
      }
      if(type == 'floor_number'){
        if(this.allRealEstatess.length > index){
          this.old_val = (this.allRealEstatess[index].floor_number == undefined) ? '' : this.allRealEstatess[index].floor_number;
        }else{
          this.old_val = '';
        }
        property = 'Floor Number';
      }
      if(type == 'unit_number'){
        if(this.allRealEstatess.length > index){
          this.old_val = (this.allRealEstatess[index].unit_number == undefined) ? '' : this.allRealEstatess[index].unit_number;
        }else{
          this.old_val = '';
        }
        property = 'Unit Number';
      }
      if(type == 'building_name'){
        if(this.allRealEstatess.length > index){
          this.old_val = (this.allRealEstatess[index].building_name == undefined) ? '' : this.allRealEstatess[index].building_name;
        }else{
          this.old_val = '';
        }
        property = 'Building Name';
      }
      if(type == 'street_number'){
        if(this.allRealEstatess.length > index){
          this.old_val = (this.allRealEstatess[index].street_number == undefined) ? '' : this.allRealEstatess[index].street_number;
        }else{
          this.old_val = '';
        }
        property = 'Street Number';
      }
      if(type == 'street_name'){
        if(this.allRealEstatess.length > index){
          this.old_val = (this.allRealEstatess[index].street_name == undefined) ? '' : this.allRealEstatess[index].street_name;
        }else{
          this.old_val = '';
        }
        property = 'Street Name';
      }
      if(type == 'city'){
        if(this.allRealEstatess.length > index){
          this.old_val = (this.allRealEstatess[index].city == undefined) ? '' : this.allRealEstatess[index].city;
        }else{
          this.old_val = '';
        }
        property = 'City';
      }

      if(type == 'postcode'){
        if(this.allRealEstatess.length > index){
          this.old_val = (this.allRealEstatess[index].postcode == undefined) ? '' : this.allRealEstatess[index].postcode;
        }else{
          this.old_val = '';
        }
        property = 'Postcode';
      }
      if(type == 'creditor'){
        if(this.allRealEstatess[index] > index && this.allRealEstatess[index].split.length > split_index){
          this.old_val = (this.allRealEstatess[index].split[split_index].creditor == undefined) ? '' : this.allRealEstatess[index].split[split_index].creditor;
        }else{
          this.old_val = '';
        }
        property = 'Creditor';
      }
      if(type == 'interest_rate'){
        if(this.allRealEstatess[index] > index && this.allRealEstatess[index].split.length > split_index){
          this.old_val = (this.allRealEstatess[index].split[split_index].interest_rate == undefined) ? '' : this.allRealEstatess[index].split[split_index].interest_rate;
        }else{
          this.old_val = '';
        }
        property = 'Interest Rate';
      }
    }
    if(this.new_val != this.old_val && property != ''){
      this.realEstate_details.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index' : index, 'split_index' : split_index});
    }
    this.realEstate_details.sort((a,b)=>a.index > b.index);
  }

  collectRealestateLogData(event, type, index, split_index = -1){
    this.new_val = event.target.value;
    this.old_val = '';
    var property = type.split("_").join(" ").toUpperCase();
    if(this.allRealEstatess != undefined){
      if(type == 'asset_type'){
        if(this.allRealEstatess.length > index && this.allRealEstatess[index].asset_type != undefined){
          this.old_val = (this.allRealEstatess[index].asset_type == undefined) ? '' : this.allRealEstatess[index].asset_type;
        }else{
          this.old_val = '';
        }
        property = 'Asset Type';
      }
      if(type == 'value_basis'){
        if(this.allRealEstatess.length > index && this.allRealEstatess[index].value_basis != undefined){
          this.old_val = (this.allRealEstatess[index].value_basis == undefined) ? '' : this.allRealEstatess[index].value_basis;
        }else{
          this.old_val = '';
        }
        property = 'Value Basis';
      }
      if(type == 'street_type'){
        if(this.allRealEstatess.length > index){
          this.old_val = (this.allRealEstatess[index].street_type == undefined) ? '' : this.allRealEstatess[index].street_type;
        }else{
          this.old_val = '';
        }
        property = 'Street Type';
      }
      if(type == 'state'){
        if(this.allRealEstatess.length > index){
          this.old_val = (this.allRealEstatess[index].state == undefined) ? '' : this.allRealEstatess[index].state;
        }else{
          this.old_val = '';
        }
        property = 'State';
      }
      if(type == 'country'){
        if(this.allRealEstatess.length > index){
          this.old_val = (this.allRealEstatess[index].country ==undefined) ? '' : this.allRealEstatess[index].country;
        }else{
          this.old_val = '';
        }
        property = 'Country';
      }
      if(type == 'loan_type'){
        if(this.allRealEstatess[index] > index && this.allRealEstatess[index].split.length > split_index){
          this.old_val = (this.allRealEstatess[index].split[split_index].loan_type == undefined) ? '' : this.allRealEstatess[index].split[split_index].loan_type;
        }else{
          this.old_val = '';
        }
        property = 'Loan Type';
      }
      if(type == 'interest_rate_term'){
        if(this.allRealEstatess[index] > index && this.allRealEstatess[index].split.length > split_index){
          this.old_val = (this.allRealEstatess[index].split[split_index].interest_rate_term == undefined) ? '' : this.allRealEstatess[index].split[split_index].interest_rate_term;
        }else{
          this.old_val = '';
        }
        property = 'Interest Rate Term';
      }
    }

    if(this.new_val != this.old_val && property != ''){
      this.realEstate_details.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index' : index, 'split_index' : split_index});
    }
    this.realEstate_details.sort((a,b)=>a.index > b.index);
  }
}


// WEBPACK FOOTER //
// ./src/pages/stepform/stepform.ts